(function () {
        // ===== CONFIG =====
        //   const API_BASE = "https://YOUR-SUPPORT-SVC.yourdomain.com/api"; // TODO
        //  const API_BASE = 'https://lively-happy-mouse.ngrok-free.app/api'
        const API_BASE = 'https://customerservice.basketsco.com/api';
        // const API_BASE = 'https://lively-happy-mouse.ngrok-free.app/api';//https://customerservice.basketsco.com/api';//https://lively-happy-mouse.ngrok-free.app/api'
        //const API_BASE = 'https://calisthenic-nonpoisonously-roseanne.ngrok-free.dev/api'
        // https://calisthenic-nonpoisonously-roseanne.ngrok-free.dev
          //const API_BASE = "https://denese-unvenerated-filchingly.ngrok-free.dev/api";

        const DOMAIN = window.location.host
       // const DOMAIN = window.location.host.replace(/^www\./, '');

        // ===== LiveAgent integration =====
        const LIVEAGENT_DOMAIN = 'giftgp.ladesk.com'
        //const LIVEAGENT_BUTTON_ID = '8m1le1r9'
        const LIVEAGENT_BUTTON_ID = 'myt0fuzd'

        let liveAgentReadyPromise = null
        let liveAgentScriptPromise = null
        let liveAgentButton = null

        function loadLiveAgentScript() {
            if (liveAgentScriptPromise) return liveAgentScriptPromise
            liveAgentScriptPromise = new Promise(function (resolve, reject) {
                if (window.LiveAgent) {
                    resolve()
                    return
                }
                const script = document.createElement('script')
                script.id = 'la_x2s6df8d'
                script.async = true
                script.src = 'https://' + LIVEAGENT_DOMAIN + '/scripts/track.js'
                script.onload = function () {
                    resolve()
                }
                script.onerror = reject
                document.head.appendChild(script)
            })
            return liveAgentScriptPromise
        }

        function initLiveAgentButton() {
            if (liveAgentReadyPromise) return liveAgentReadyPromise
            liveAgentReadyPromise = loadLiveAgentScript().then(function () {
                if (!window.LiveAgent) {
                    console.error('LiveAgent script loaded but LiveAgent object missing')
                    return null
                }
                if (!liveAgentButton) {
                    let container = document.getElementById('liveagent-hidden-btn')
                    if (!container) {
                        container = document.createElement('div')
                        container.id = 'liveagent-hidden-btn'
                        container.style.display = 'none'
                        document.body.appendChild(container)
                    }
                    liveAgentButton = window.LiveAgent.createButton(
                        LIVEAGENT_BUTTON_ID,
                        container
                    )
                    if (liveAgentButton) {
                        liveAgentButton._origOnClick = liveAgentButton.onClick
                    }
                }
                return liveAgentButton
            })
            return liveAgentReadyPromise
        }

        function liveAgentOpenChat() {
            initLiveAgentButton()
                .then(function (btn) {
                    if (!btn) return
                    const overlay = document.getElementById('sw-overlay')
                    const fab = document.getElementById('sw-fab')
                    if (overlay) overlay.remove()
                    if (fab) fab.style.display = ''
                    if (typeof btn._origOnClick === 'function') {
                        btn._origOnClick.call(btn, {type: 'click'})
                    } else if (typeof btn.onClick === 'function') {
                        btn.onClick.call(btn, {type: 'click'})
                    }
                })
                .catch(function (err) {
                    console.error('Failed to open LiveAgent chat:', err)
                })
        }

        document.addEventListener('DOMContentLoaded', function () {
            initLiveAgentButton().catch(function (err) {
                console.error('LiveAgent preload failed:', err)
            })
        })


        const ICONS = {
            ORDER_STATUS: `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" fill-rule="evenodd" clip-rule="evenodd" d="M2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3H3.21922L6.78345 17.2569C5.73276 17.7236 5 18.7762 5 20C5 21.6569 6.34315 23 8 23C9.65685 23 11 21.6569 11 20C11 19.6494 10.9398 19.3128 10.8293 19H15.1707C15.0602 19.3128 15 19.6494 15 20C15 21.6569 16.3431 23 18 23C19.6569 23 21 21.6569 21 20C21 18.3431 19.6569 17 18 17H8.78078L8.28078 15H18C20.0642 15 21.3019 13.6959 21.9887 12.2559C22.6599 10.8487 22.8935 9.16692 22.975 7.94368C23.0884 6.24014 21.6803 5 20.1211 5H5.78078L5.15951 2.51493C4.93692 1.62459 4.13696 1 3.21922 1H2ZM18 13H7.78078L6.28078 7H20.1211C20.6742 7 21.0063 7.40675 20.9794 7.81078C20.9034 8.9522 20.6906 10.3318 20.1836 11.3949C19.6922 12.4251 19.0201 13 18 13ZM18 20.9938C17.4511 20.9938 17.0062 20.5489 17.0062 20C17.0062 19.4511 17.4511 19.0062 18 19.0062C18.5489 19.0062 18.9938 19.4511 18.9938 20C18.9938 20.5489 18.5489 20.9938 18 20.9938ZM7.00617 20C7.00617 20.5489 7.45112 20.9938 8 20.9938C8.54888 20.9938 8.99383 20.5489 8.99383 20C8.99383 19.4511 8.54888 19.0062 8 19.0062C7.45112 19.0062 7.00617 19.4511 7.00617 20Z" />
      </svg>`,
            DAMAGE: `<svg width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g>
        <path fill="none" d="M0 0h24v24H0z"/>
        <path  fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" fill-rule="nonzero" d="M19 9h-5V4H5v7.857l1.5 1.393L10 9.5l3 5 2-2.5 3 3-3-.5-2 2.5-3-4-3 3.5-2-1.25V20h14V9zm2-1v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8z"/>
    </g>
</svg>`,
            CHANGES: `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" fill-rule="evenodd" clip-rule="evenodd" d="M20.8477 1.87868C19.6761 0.707109 17.7766 0.707105 16.605 1.87868L2.44744 16.0363C2.02864 16.4551 1.74317 16.9885 1.62702 17.5692L1.03995 20.5046C0.760062 21.904 1.9939 23.1379 3.39334 22.858L6.32868 22.2709C6.90945 22.1548 7.44285 21.8693 7.86165 21.4505L22.0192 7.29289C23.1908 6.12132 23.1908 4.22183 22.0192 3.05025L20.8477 1.87868ZM18.0192 3.29289C18.4098 2.90237 19.0429 2.90237 19.4335 3.29289L20.605 4.46447C20.9956 4.85499 20.9956 5.48815 20.605 5.87868L17.9334 8.55027L15.3477 5.96448L18.0192 3.29289ZM13.9334 7.3787L3.86165 17.4505C3.72205 17.5901 3.6269 17.7679 3.58818 17.9615L3.00111 20.8968L5.93645 20.3097C6.13004 20.271 6.30784 20.1759 6.44744 20.0363L16.5192 9.96448L13.9334 7.3787Z" fill="#0F0F0F"/>
</svg>`,
            CANCEL: `<svg fill="#000000" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" d="M461.913,139.13h-26.476L306.761,10.455c-6.519-6.519-17.091-6.519-23.611,0L244.87,48.737l-38.282-38.282
			c-6.519-6.519-17.091-6.519-23.611,0L54.302,139.13H16.696C7.475,139.13,0,146.606,0,155.826v333.913
			c0,9.22,7.475,16.696,16.696,16.696H395.13h66.783c27.618,0,50.087-22.469,50.087-50.087v-66.783V256v-66.783
			C512,161.598,489.531,139.13,461.913,139.13z M294.957,45.872l93.259,93.259h-52.952l-66.783-66.783L294.957,45.872z
			 M194.783,45.872l38.282,38.282l54.977,54.977H101.524L194.783,45.872z M411.826,456.348c0,9.206-7.49,16.696-16.696,16.696
			H33.391V172.522h27.826h267.13h66.783c9.206,0,16.696,7.49,16.696,16.696v50.087h-50.087c-46.03,0-83.478,37.448-83.478,83.478
			s37.448,83.478,83.478,83.478h50.087V456.348z M478.609,456.348c0,9.206-7.49,16.696-16.696,16.696h-19.567
			c1.853-5.226,2.872-10.843,2.872-16.696v-50.087h33.391V456.348z M478.609,372.869h-50.087h-66.783
			c-27.618,0-50.087-22.469-50.087-50.087s22.469-50.087,50.087-50.087h66.783h50.087V372.869z M478.609,239.304h-33.391v-50.087
			c0-5.852-1.018-11.47-2.872-16.696h19.567c9.206,0,16.696,7.489,16.696,16.696V239.304z"/>
	</g>
</g>
<g>
	<g>
		<circle cx="361.739" cy="322.783" r="16.696"/>
	</g>
</g>
</svg>`,
            DELIVERY: `<svg width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" d="M14,9 L18.5,11 L23,9 L23,4 L18.5,2 L14,4 L14,9 Z M7,7 C4.791,7 3,8.791 3,11 C3,13.209 4.791,15 7,15 C9.209,15 11,13.209 11,11 C11,8.791 9.209,7 7,7 L7,7 Z M1,23 L1,21 C1,17 3.5,15 7,15 C10.5,15 13,17 13,21 L13,23 L1,23 Z M14,4 L18.5,6 L23,4 M18.5,6 L18.5,11 L18.5,6 Z"/>
</svg>`,
            GENERAL: `<svg height="20px" width="20px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 512 512"  xml:space="preserve">
<g>
	<path fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" class="st0" d="M396.138,85.295c-13.172-25.037-33.795-45.898-59.342-61.03C311.26,9.2,280.435,0.001,246.98,0.001
		c-41.238-0.102-75.5,10.642-101.359,25.521c-25.962,14.826-37.156,32.088-37.156,32.088c-4.363,3.786-6.824,9.294-6.721,15.056
		c0.118,5.77,2.775,11.186,7.273,14.784l35.933,28.78c7.324,5.864,17.806,5.644,24.875-0.518c0,0,4.414-7.978,18.247-15.88
		c13.91-7.85,31.945-14.173,58.908-14.258c23.517-0.051,44.022,8.725,58.016,20.717c6.952,5.941,12.145,12.594,15.328,18.68
		c3.208,6.136,4.379,11.5,4.363,15.574c-0.068,13.766-2.742,22.77-6.603,30.442c-2.945,5.729-6.789,10.813-11.738,15.744
		c-7.384,7.384-17.398,14.207-28.634,20.479c-11.245,6.348-23.365,11.932-35.612,18.68c-13.978,7.74-28.77,18.858-39.701,35.544
		c-5.449,8.249-9.71,17.686-12.416,27.641c-2.742,9.964-3.98,20.412-3.98,31.071c0,11.372,0,20.708,0,20.708
		c0,10.719,8.69,19.41,19.41,19.41h46.762c10.719,0,19.41-8.691,19.41-19.41c0,0,0-9.336,0-20.708c0-4.107,0.467-6.755,0.917-8.436
		c0.773-2.512,1.206-3.14,2.47-4.668c1.29-1.452,3.895-3.674,8.698-6.331c7.019-3.946,18.298-9.276,31.07-16.176
		c19.121-10.456,42.367-24.646,61.972-48.062c9.752-11.686,18.374-25.758,24.323-41.968c6.001-16.21,9.242-34.431,9.226-53.96
		C410.243,120.761,404.879,101.971,396.138,85.295z"/>
	<path fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" class="st0" d="M228.809,406.44c-29.152,0-52.788,23.644-52.788,52.788c0,29.136,23.637,52.772,52.788,52.772
		c29.136,0,52.763-23.636,52.763-52.772C281.572,430.084,257.945,406.44,228.809,406.44z"/>
</g>
</svg>`,
            LIVECHAT: `<svg height="20px" width="20px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 512 512"  xml:space="preserve">
<g>
	<path fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"  class="st0" d="M96.01,396.095l25.617-57.286l-11.716-5.998c-25.192-12.899-45.85-30.44-60.068-50.656
		c-14.227-20.252-22.076-43.024-22.094-67.295c0.009-19.051,4.85-37.144,13.775-53.864c13.386-25.057,36.158-46.97,65.379-62.579
		C136.107,82.8,171.651,73.542,210.05,73.55c41.055-0.008,78.749,10.604,108.928,28.237c30.215,17.632,52.761,42.202,64.268,69.914
		l25.617-10.66c-14.235-34.207-41.252-62.986-75.885-83.22C298.31,57.589,255.874,45.81,210.05,45.801
		C152.909,45.82,100.933,64.057,62.725,94.244c-19.087,15.103-34.741,33.242-45.67,53.665C6.134,168.313-0.009,191.05,0,214.861
		c-0.018,30.378,10.008,58.93,27.152,83.264c14.796,21.029,34.867,38.986,58.579,52.996l-35.12,78.523l24.099-2.674
		c49.474-5.51,97.6-17.271,137.544-29.248l-7.968-26.574C172.166,380.784,134.671,390.161,96.01,396.095z"/>
	<path fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"  class="st0" d="M492.092,370.848c12.537-17.776,19.926-38.786,19.908-61.134c0.009-17.506-4.516-34.244-12.519-49.193
		c-12.032-22.447-31.688-40.955-55.877-53.89c-24.208-12.934-53.059-20.342-83.969-20.351
		c-41.208,0.018-78.776,13.152-106.543,35.084c-13.874,10.975-25.301,24.199-33.314,39.158
		c-8.003,14.949-12.528,31.687-12.52,49.193c-0.018,26.791,10.587,51.56,27.921,71.332c17.18,19.619,40.892,34.622,68.298,43.411
		c28.489,11.039,88.395,32.04,151.254,39.068l24.1,2.673l-26.312-58.804C468.344,397.532,481.93,385.274,492.092,370.848z
		 M428.456,389.357l-11.716,5.997l16.602,37.108c-49.952-8.491-96.435-24.76-119.821-33.873l-0.424-0.163l-0.434-0.136
		c-23.395-7.352-43.059-20.008-56.59-35.508c-13.558-15.555-21.047-33.639-21.065-53.068c0.009-12.746,3.234-24.841,9.241-36.105
		c9.006-16.873,24.47-31.823,44.486-42.509c19.999-10.694,44.442-17.08,70.9-17.072c35.272-0.018,66.96,11.372,89.316,29.095
		c11.192,8.853,20.044,19.24,26.051,30.486c6.016,11.264,9.24,23.359,9.25,36.105c-0.018,16.24-5.248,31.47-14.859,45.164
		C459.79,368.545,445.726,380.523,428.456,389.357z"/>
</g>
</svg>`
        }

        const ISSUE = [
            {id: 'ORDER_STATUS', label: 'Order status', icon: 'ORDER_STATUS'},
            {id: 'DELIVERY', label: 'Delivery issues', icon: 'DELIVERY'},
            {id: 'DAMAGE', label: 'Damages', icon: 'DAMAGE'},
            {id: 'CHANGES', label: 'Change order', icon: 'CHANGES'},
            {id: 'CANCEL', label: 'Cancel order', icon: 'CANCEL'},
            {id: 'GENERAL', label: 'General Question', icon: 'GENERAL'},
            {id: 'LIVECHAT', label: 'I would like to chat with an agent', icon: 'LIVECHAT'}
        ]

        const ISSUE_COLORS = {
            ORDER_STATUS: '#00b2d9',
            DELIVERY: '#c96659',
            DAMAGE: '#58c78f',
            CHANGES: '#eda201',
            CANCEL: '#d36bf1',
            GENERAL: '#c9c959',
            LIVECHAT: '#5982c9'
        }

        const DAMAGE_SUBTYPES = [
            'Broken item(s)',
            'Leaking / melted',
            'Missing item(s)',
            'Packaging damage',
            'Other'
        ]
        const CHANGE_TYPES = [
            'Change address',
            'Change delivery date',
            'Change products',
            //'Cancel order',
            'Other'
        ]
        const REFUND_REASONS = [
            'Delivery was late',
            'Item arrived damaged',
            'Missing item(s)',
            'Product quality concern',
            'Wrong item received',
            'Order placed in error',
            'Recipient unavailable / refused',
            'Other'
        ]
        const RECIPIENT = ['Yes', 'No', 'Not sure']

        const historyIcon = '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LocalShippingIcon"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9 1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path></svg>'

        // ===== STATE =====
        const state = {
            // answers
            issue_type: '',
            recipient_received: '',
            damage_subtype: '',
            change_request_type: '',
            refund_reason: '',
            email: '',
            customerName: '',
            order_number: '',
            postal_code: '',
            order_found: null,
            message: '',
            files: [],
            // gating choices (this is what creates “AI feel”)
            has_order_number: null, // true/false
            wants_lookup: null, // true/false (use postal lookup)
            active: 'issue', // issue | quick | order_gate | order_fields | message | submit
            submitting: false,
            fromBack: false,
            show_history: false,
            lock_step: null,
            // verify_status: null,
            lookup_status: null,
            verify_status: '', // "", "success", "error"
            tracking_expanded: false, // collapsed by default
            tracking_history: [], // full tracking data from API
            tracking_order: null,
            tracking_modal_open: false,
            tracking_modal_first_open: false,
            help_mode: null,
            order_back: false,
            liveAgentMessage: '',
            orders: [],
            thank_you_switch: false,
            delivery_issue: "",
            changes_request: "",
            cancel_request: '',
            general_question: "",
            damage_issue: "",
            damage_files: [],
            show_submit_button: false,
            is_order_status: null,
            showOnlineChatOnBack:true,//false,
            orderAlreadyFulfilled:false
        }

        function resetOrderFlow() {
            console.log('do reset the state');
            Object.assign(state, {
                issue_type: '',
                recipient_received: '',
                damage_subtype: '',
                change_request_type: '',
                refund_reason: '',
                email: '',
                order_number: '',
                postal_code: '',
                order_found: null,
                message: '',
                files: [],
                has_order_number: null,
                wants_lookup: null,
                active: 'issue',
                submitting: false,
                fromBack: false,
                show_history: false,
                lock_step: null,
                lookup_status: null,
                verify_status: '',
                tracking_expanded: false,
                tracking_history: [],
                tracking_order: null,
                tracking_modal_open: false,
                tracking_modal_first_open: false,
                help_mode: false,
                order_back: false,
                liveAgentMessage: '',
                orders: [],
                thank_you_switch: false,
                delivery_issue: '',
                changes_request: '',
                cancel_request: '',
                general_question: '',
                damage_issue: '',
                damage_files: [],
                show_submit_button: false,
                is_order_status: null,
                showOnlineChatOnBack:false,
                orderAlreadyFulfilled:false
            })
        }

        function isOrderRelated(t) {
            return ['ORDER_STATUS', 'DAMAGE', 'CHANGES', 'CANCEL', 'BILLING'].includes(t)
        }

        function nonEmpty(s) {
            return (s || '').trim().length > 0
        }

        function clamp(s, max) {
            s = (s || '').toString()
            return s.length <= max ? s : s.slice(0, max)
        }

        function uniqFiles(files) {
            const seen = new Set()
            const out = []
            for (const f of files) {
                const k = `${f.name}|${f.size}|${f.lastModified}`
                if (seen.has(k)) continue
                seen.add(k)
                out.push(f)
            }
            return out.slice(0, 10)
        }

        function getUTM() {
            const p = new URLSearchParams(window.location.search)
            return {
                source: p.get('utm_source') || undefined,
                medium: p.get('utm_medium') || undefined,
                campaign: p.get('utm_campaign') || undefined,
                term: p.get('utm_term') || undefined,
                content: p.get('utm_content') || undefined
            }
        }

        function el(tag, attrs = {}, children = []) {
            const n = document.createElement(tag)
            Object.entries(attrs).forEach(([k, v]) => {
                if (k === 'class') n.className = v
                else if (k === 'text') n.textContent = v
                else if (k === 'html') n.innerHTML = v
                else if (k.startsWith('on') && typeof v === 'function')
                    n.addEventListener(k.slice(2), v)
                else n.setAttribute(k, v)
            })
            children.forEach(c => n.appendChild(c))
            return n
        }

        function backToPrevious(id) {
            // if (id === 'order_gate') {
            //   return 'issue'
            // }
            console.log('resetOrderFlow backToPrevious', id);

            if (id === 'quick') return 'issue'
            if (id === 'order_confirmation') {
                return 'issue'
            }


            if (state.issue_type === 'DELIVERY') {
                if (id === 'delivery_concern') {
                    //resetOrderFlow()
                    return 'order_gate';//order_confirmation_delivery';

                }
                if (id === 'order_confirmation_delivery') {
                    return 'issue'
                }
                //state.lookup_status = 'loading'
                //if (state.issue_type==='DAMAGE') {
                if (id === 'order_gate' && state.lookup_status !== 'loading') { //' && state.delivery_issue !== "") {
                    // state.has_order_number = null
                    return 'order_confirmation_delivery'
                }
                //}
            }

            //if (id === 'order_confirmation_delivery' && state.delivery_issue !== "") return 'delivery_concern'
///////

            if (state.issue_type === 'CHANGES') {
                if (id === 'order_confirmation_changes') return 'issue'
                if (id === 'changes_concern') {
                    //resetOrderFlow()
                    return 'quick';//order_gate';//order_confirmation_changes'
                }
                if (id === 'quick') {
                    return 'order_gate';
                }

                if (id === 'order_gate' && state.lookup_status !== 'loading') {
                    // state.has_order_number = null
                    return 'order_confirmation_changes'
                }
                //if (id === 'order_confirmation_changes' && state.changes_request !== "") return 'changes_concern'
            }


            if (state.issue_type === 'CANCEL') {
// && state.cancel_request !== ""
                if (id === 'order_confirmation_cancel') return 'issue'
                //cancel_concern'

                if (id === 'cancel_concern') {
                    //resetOrderFlow()
                    return 'order_gate';//order_confirmation_cancel'
                }


                if (id === 'order_gate' && state.lookup_status !== 'loading') { //' && state.delivery_issue !== "") {
                    // state.has_order_number = null
                    return 'order_confirmation_cancel'
                }

            }

            if (id === 'general_concern') {
                //resetOrderFlow()
                return 'issue'
            }

            if (id === 'general_email') {
                return 'general_concern'
            }

            if (state.issue_type === 'DAMAGE') {

                if (id === 'order_confirmation_damage') return 'issue'
                if (id === 'damage_upload' && state.damage_issue !== "") return 'damage_concern'
                //if (id === 'order_confirmation_damage' && state.damage_issue !== "") return 'damage_upload'
                if (id === 'damage_concern') {
                    //resetOrderFlow()
                    return 'order_gate'//order_confirmation_damage'
                }

                //if (id === 'order_gate' && state.damage_issue !== "") {
                if (id === 'order_gate' && state.lookup_status !== 'loading') {
                    console.log('id state ', id, state);
                    // state.has_order_number = null
                    return 'order_confirmation_damage';//order_gate';//order_confirmation_damage'
                }
            }
            ////////
            if (id === 'order_gate' && state.is_order_status !== null) {
                // state.has_order_number = null
                return 'order_confirmation'
            }

            if (id === 'order_fields') return 'issue'
            if (id === 'fallback_message' && state.order_back === true) return 'order_gate'
            if (id === 'fallback_message' && state.order_back === false) return 'order_fields'
            if (id === 'fallback_message' && state.issue_type === 'DAMAGE') return 'quick'
            // hereee

            // if (id === 'message') return 'order_fields'
            if (id === 'submit' && state.sendTicket == true) return null
            if (id === 'submit' && state.general_question !== "") return 'general_email'
            if (id === 'submit') {
                if (state.issue_type === 'DAMAGE')
                    return 'damage_upload'
                if (state.issue_type === 'CANCEL')
                    return 'cancel_concern'
                if (state.issue_type === 'CHANGES')
                    return 'changes_concern'

                if (state.issue_type === 'DELIVERY')
                    return 'delivery_concern'
                return 'fallback_message'
            }
            return null
        }

        function cardSubmitButton(id) {
            // if (id === 'quick') return 'issue'
            // if (id === 'order_confirmation')
            // {
            //   return 'issue'
            // }
            if (id === 'delivery_concern') {
                return {value: true, text: "Submit"}
            }

            if (id === 'order_gate' && state.delivery_issue !== "" && state.show_submit_button === true) {
                return {value: true, text: "Submit Ticket"}
            }
            // if (id === 'order_gate') {
            //   return 'order_confirmation'
            // }

            return null
        }

        // ===== FLOW LOGIC =====
        function computeNextActive() {
            // This is the “agentic brain”: it chooses the next question.
            // 🔒 HARD LOCK (prevents auto-advance)
            // if (
            //   state.active === 'order_fields' &&
            //   isOrderRelated(state.issue_type) &&
            //   state.has_order_number === true
            // ) {
            //   return 'order_fields'
            // }
            // console.log("ISSUE TYPE: ", state.issue_type)

            if (state.active === 'order_confirmation_delivery') {
                if (state.has_order_number === true) {
                    state.help_mode = false
                    return 'order_gate'
                }
                if (state.has_order_number === false) {
                    state.help_mode = true
                    return 'order_gate'
                }
                //state.lookup_status = 'loading'
                console.log('state.lookup_status', state.lookup_status);
                if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                    return 'order_gate';

                console.log('state.lookup_status2', state.lookup_status);

                return 'order_confirmation_delivery'
            }


            if (state.active === 'order_confirmation_delivery' && !state.delivery_issue) {
                return 'delivery_concern'
            }
            if (state.issue_type === "DELIVERY" && state.delivery_issue==='' && state.active ==='delivery_concern') 
                return 'delivery_concern';

            if (state.issue_type === "DELIVERY" && !state.delivery_issue) {
                if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                    return 'order_gate';

                return 'order_confirmation_delivery'
                //return 'delivery_concern'
            }
            
            // if (state.active === 'delivery_concern' && state.delivery_issue) {
            //     return 'order_confirmation_delivery'
            // }


            if (state.issue_type === "CANCEL") {


                if (state.active === 'order_confirmation_cancel') {
                    if (state.has_order_number === true) {
                        state.help_mode = false
                        return 'order_gate'
                    }
                    if (state.has_order_number === false) {
                        state.help_mode = true
                        return 'order_gate'
                    }
                    if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                        return 'order_gate';

                    return 'order_confirmation_cancel'
                }

                // if (state.active === 'cancel_concern' && state.cancel_request) {
                //     return 'order_confirmation_cancel'
                // }

                if (state.active === 'order_gate' && state.order_found !== null) {
                    return 'order_gate';//cancel_concern';
                }
                //if (state.issue_type === "CANCEL" && !state.cancel_request) {

                //return 'order_confirmation_cancel';//cancel_concern'
                //}
                if (state.order_found === null) {
                    if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                        return 'order_gate';

                    //if (state.active === 'order_confirmation_cancel') {
                    return 'order_confirmation_cancel';
                }
            }

            if (state.active === 'order_confirmation_damage') {
                if (state.has_order_number === true) {
                    state.help_mode = false
                    return 'order_gate'
                }
                if (state.has_order_number === false) {
                    state.help_mode = true
                    return 'order_gate'
                }
                if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                    return 'order_gate';
                return 'order_confirmation_damage'
            }


            /// damage
            if (state.issue_type === "DAMAGE") {
                if (state.damage_issue === "" && state.order_found === null) {//} && state.help_mode === null) {
                    console.log('order_confirmation_damage DAMAGE', state);
                    if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                        return 'order_gate';
                    return 'order_confirmation_damage';//damage_concern'
                }
                if (state.damage_issue === "" && state.order_found !== null) {
                    //return 'damage_concern';//damage_concern'
                }


                if (state.active === 'damage_concern' && state.damage_issue) {
                    return 'damage_upload'
                }

                // if (state.active === 'damage_upload' && state.damage_issue) {// change this
                //   return 'order_confirmation_damage'
                // }

                if (
                    state.active === 'damage_upload' &&
                    state.damage_files &&
                    state.damage_files.length > 0
                ) {
                    return 'order_confirmation_damage'
                }
            }

            /*if (state.active === 'order_confirmation_damage') {
                if (state.has_order_number === true) {
                    state.help_mode = false
                    return 'order_gate'
                }
                if (state.has_order_number === false) {
                    state.help_mode = true
                    return 'order_gate'
                }
                return 'order_confirmation_damage'
            }*/

            if (state.issue_type === "ORDER_STATUS" && state.is_order_status === null) {
                state.is_order_status = true
                if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                    return 'order_gate';

                return 'order_confirmation'
            }

            // if (
            //   state.issue_type === "ORDER_STATUS" &&
            //   state.has_order_number !== null
            // ) {
            //   state.help_mode = state.has_order_number === false
            //   return 'order_gate'
            // }

            if (
                state.issue_type === "ORDER_STATUS" &&
                state.has_order_number !== null
            ) {
                state.help_mode = state.has_order_number === false
                return 'order_gate'
            }

            if (state.active === 'order_confirmation') {
                if (state.has_order_number === true) {
                    state.help_mode = false
                    return 'order_gate'
                }

                if (state.has_order_number === false) {
                    state.help_mode = true
                    return 'order_gate'
                }

                if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                    return 'order_gate';

            }


            if (state.issue_type === "CHANGES") {
                //return 'quick';//order_confirmation_changes'
                if (state.active === 'order_confirmation_changes') {
                    if (state.has_order_number === true) {
                        state.help_mode = false
                        return 'order_gate'
                    }
                    if (state.has_order_number === false) {
                        state.help_mode = true
                        return 'order_gate'
                    }

                    if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                        return 'order_gate';

                    return 'order_confirmation_changes'
                }

                // else if (state.issue_type === 'CHANGES')
                //     state.active = "quick";
                //state.active = "changes_concern";

                if (state.active === 'quick'){//} && state.changes_request) {
                    return 'changes_concern'
                }

                if (state.active === 'changes_concern' && state.changes_request) {
                    return 'quick';//order_confirmation_changes'
                }
                if (state.issue_type === "CHANGES" && state.changes_request === "") {
                    if (state.lookup_status === 'loading' || state.lookup_status === 'failed')
                        return 'order_gate';

                    return 'order_confirmation_changes';//changes_concern'
                }

                console.log('CHANGES state.issue_type', state);


            }

            if (state.issue_type === "GENERAL" && !state.general_question) {
                return 'general_concern'
            }

            if (state.active === 'general_concern' && state.general_question) {
                return 'general_email'
            }

            if (state.active === 'order_gate') {
                // console.log("lookup Successs")

                return 'order_gate'
            }


            if (state.active === 'fallback_message') return 'fallback_message'

            if (state.lock_step) {
                return state.lock_step
            }

            if (!state.issue_type) return 'issue'

            if (!quickDetailSatisfied()) return 'quick'

            // if (!nonEmpty(state.message)) return 'message'

            return 'submit'
        }

        function quickDetailSatisfied() {
            // if(state.issue_type === "ORDER_STATUS") return nonEmpty(state.recipient_received);
            if (state.issue_type === 'DELIVERY') return nonEmpty(state.delivery_issue)
            if (state.issue_type === 'CHANGES') return nonEmpty(state.changes_request)
            if (state.issue_type === 'CANCEL') return nonEmpty(state.cancel_request)


            if (state.issue_type === 'DAMAGE') return nonEmpty(state.damage_issue)
            // if (state.issue_type === 'CHANGES')
            //   return nonEmpty(state.change_request_type)
            if (state.issue_type === 'BILLING') return nonEmpty(state.refund_reason)

            // corporate/general skip quick detail
            return true
        }

        function canSubmit() {
            if (!state.issue_type) return false
            if (!nonEmpty(state.email)) return false
            if (isOrderRelated(state.issue_type)) {
                if (state.has_order_number === null) return false
                if (state.has_order_number === true && !nonEmpty(state.order_number))
                    return false
                if (state.has_order_number === false && !nonEmpty(state.postal_code))
                    return false
            }
            if (!nonEmpty(state.message)) return false
            return true
        }

        // ===== UI MOUNT =====
        function mount() {
            const contactUsButton=document.getElementById('supportContactUs');
            if (contactUsButton!==undefined && contactUsButton!==null)
            {
                contactUsButton.addEventListener('click', open);
//contactUsButton
            }
            
            if (document.getElementById('sw-fab')) return
            const fab = el('button', {
                id: 'sw-fab',
                class: 'sw-fab',
                type: 'button',
                text: 'Support',
                onclick: open
            })
            document.body.appendChild(fab)
        }

        function open() {
            if (document.getElementById('sw-overlay')) return
            // const overlay = el("div",{id:"sw-overlay",class:"sw-overlay"});

            const fab = document.getElementById('sw-fab')
            if (fab) fab.style.display = 'none'

            const overlay = el('div', {id: 'sw-overlay', class: 'sw-overlay'})
            const modal = el('div', {class: 'sw-modal'})
            const head = el('div', {class: 'sw-head'})
            head.appendChild(
                el('div', {
                    html: `<div class="sw-title"></div><div class="sw-sub"></div>`
                })
            )
            const close = el(
                'button',
                {class: 'sw-close', type: 'button', 'aria-label': 'Close'},
                [document.createTextNode('×')]
            )
            close.onclick = () => {
                ////hereee
                overlay.remove()
                if (fab) fab.style.display = ''
                if (state.thank_you_switch === true) {
                    state.thank_you_switch = false
                    resetOrderFlow()
                }
            }
            head.appendChild(close)

            const body = el('div', {class: 'sw-body'})
            const left = el('div', {class: 'sw-left'})
            //   const right=el("div",{class:"sw-right"});

            body.appendChild(left)
            //   body.appendChild(right);
            modal.appendChild(head)
            modal.appendChild(body)
            overlay.appendChild(modal)
            document.body.appendChild(overlay)

            overlay.addEventListener('click', e => {
                if (e.target === overlay) {
                    overlay.remove()
                    if (fab) fab.style.display = ''
                }
            })

            function render() {

                console.log("TESTDATA: ", state)
                console.log("TESTDATA state.active1", state.active)
                // compute next step ONLY if not locked
                if (state.active !== 'submit' && !state.fromBack && !state.lock_step) {
                    state.active = computeNextActive()
                    console.log("TESTDATA state.active2", state.active)
                }
                const headTitle = document.querySelector('.sw-title')
                const headSub = document.querySelector('.sw-sub')

                if (headTitle && headSub) {
                    const h = headerFor(state.active)
                    headTitle.textContent = h.title || ''
                    headSub.textContent = h.hint || ''
                }
                state.fromBack = false

                left.innerHTML = ''
                left.appendChild(renderRail())

                const existingModal = document.querySelector('.sw-modal1-overlay')
                if (existingModal) existingModal.remove() // remove old modal

                if (state.tracking_modal_open) {
                    overlay.appendChild(renderTrackingModal())
                }
            }

            function card({id, title, hint, mini, controls}) {
                console.log('card id', id);

                const modalCommon = document.querySelector('.sw-modal');
                if (modalCommon!==null && modalCommon!==undefined)
                {
                    modalCommon.className = '';
                    modalCommon.className = 'sw-modal';
                    if (state.issue_type!=='')
                    {
                        modalCommon.classList.add(state.issue_type);
                        if (state.active!=='')
                            modalCommon.classList.add(state.active);

                    }else if (modalCommon!==null && modalCommon!==undefined){
                        //modalCommon.classList.add(state.active);
                    }
                }


                
                const active = state.active === id
                const done = isDone(id)
                const c = el('div', {
                    class: `sw-card ${state.issue_type} ${state.active} ${active ? 'active' : ''} ${done ? 'done' : ''}`
                })

                const ctl = el('div', {class: 'sw-controls'})

                // main controls
                if (typeof controls === 'function') controls(ctl)

                // back row
                // const backId = backToPrevious();

                const backRow = el('div', {class: 'sw-back-row'})
                const backId = backToPrevious(id)
                if (backId) {

                    const backBtn = el('button', {
                        class: 'sw-btn sw-back',
                        type: 'button',
                        text: '← Back'
                    })

                    backBtn.onclick = e => {
                        e.stopPropagation()
                        console.log('state.backId c.onclick ', id, state, backId);
                        state.fromBack = true
                        state.active = backId
                        state.lock_step = null

                        // 🔥 IMPORTANT: reset downstream answers when going back to issue
                        // if (backId === 'issue') {
                        //   state.issue_type = 'issue'
                        //   // state.has_order_number = null
                        //   // state.wants_lookup = null
                        //   // state.order_number = ''
                        //   // state.postal_code = ''
                        //   // state.order_found = null
                        //   // state.verify_status = null
                        //   // state.lookup_status = null
                        // }

                        render()
                    }

                    backRow.appendChild(backBtn);

                    if (state.showOnlineChatOnBack) {

                        const chatBtn = el('button', {
                            class: 'sw-btn ghost sw-button-with-back',
                            type: 'button',
                            text: 'Chat with us'
                        })
                        chatBtn.onclick = () => {
                            liveAgentOpenChat({
                                containerEl: null,
                                prefill: {
                                    email: state.email,
                                    message: ''
                                }
                            })
                        }
                        backRow.appendChild(chatBtn);
                    }



                }


                // const submitId = cardSubmitButton(id)
                // if (submitId) {
                //   const submitBtn = el('button', {
                //     class: 'sw-btn sw-back',
                //     type: 'button',
                //     text: '← Back'
                //   })

                //   submitBtn.onclick = e => {
                //     e.stopPropagation()

                //     state.fromBack = true
                //     state.active = backId
                //     state.lock_step = null

                //     // 🔥 IMPORTANT: reset downstream answers when going back to issue
                //     // if (backId === 'issue') {
                //     //   state.issue_type = ''
                //     //   state.has_order_number = null
                //     //   state.wants_lookup = null
                //     //   state.order_number = ''
                //     //   state.postal_code = ''
                //     //   state.order_found = null
                //     //   state.verify_status = null
                //     //   state.lookup_status = null
                //     // }

                //     render()
                //   }

                //   backRow.appendChild(submitBtn)
                // }

                ctl.appendChild(backRow)

                // clicking done card to reopen
                if (done && !active) {
                    c.style.cursor = 'pointer'
                    c.onclick = () => {
                        console.log('state.active c.onclick ', id, state);
                        state.active = id
                        // state.fromBack = true;
                        render()
                    }
                }

                c.appendChild(ctl)
                return c
            }

            function isDone(id) {
                // Done means: this card's requirement is satisfied AND it's not the computed next active
                if (id === 'issue') return !!state.issue_type && state.active !== 'issue'
                if (id === 'quick')
                    return quickDetailSatisfied() && state.active !== 'quick'
                if (id === 'order_gate')
                    return state.has_order_number !== null && state.active !== 'order_gate'
                if (id === 'order_fields') {
                    // For order related: email always required + (order# or postal) based on gate.
                    if (!nonEmpty(state.email)) return false
                    if (isOrderRelated(state.issue_type)) {
                        if (state.has_order_number === true)
                            return (
                                nonEmpty(state.order_number) && state.active !== 'order_fields'
                            )
                        if (state.has_order_number === false)
                            return (
                                nonEmpty(state.postal_code) && state.active !== 'order_fields'
                            )
                        return false
                    }
                    return state.active !== 'order_fields'
                }
                if (id === 'message')
                    return nonEmpty(state.message) && state.active !== 'message'
                if (id === 'submit') return canSubmit() // submit stays active at end, but can be considered done after confirm
                return false
            }

            function chips(options, selected, onPick, mode = 'pills') {
                mode = mode === 'tiles' ? 'tiles' : 'pills'
                const row = el('div', {class: `sw-chips ${mode}`})

                options.forEach(o => {
                    const val = o.id ?? o
                    const label = o.label ?? o
                    const icon = o.icon ?? null

                    const b = el('button', {
                        class: `sw-chip sw-chip-${val} ${mode === 'tiles' ? 'tile' : ''} ${
                            selected === val ? 'sel' : ''
                        }`,
                        type: 'button'
                    })

                    if (mode === 'tiles' && icon) {
                        const bgColor = ISSUE_COLORS[val] || '#EEE'

                        b.style.backgroundColor = bgColor
                        b.style.border = `2px solid ${bgColor}`
                        b.style.display = 'flex'
                        b.style.flexDirection = 'column'
                        b.style.alignItems = 'flex-start' // ✅ center horizontally
                        b.style.justifyContent = 'space-between' // ✅ center vertically
                        b.innerHTML = `
        <div class="sw-tile-icon">
          ${ICONS[icon] || ''}
        </div>
        <div class="sw-tile-label">${label}</div>
      `
                    } else {
                        b.textContent = label
                    }

                    b.onclick = e => {
                        e.stopPropagation()
                        onPick(val)
                    }

                    row.appendChild(b)
                })

                return row
            }

            function headerFor(activeId) {
                switch (activeId) {
                    case 'issue':
                        return {
                            title: 'What can we help you with today?',
                            hint: 'Choose one option to begin.'
                        }

                    case 'quick':
                        return {
                            title: 'Type of changes',//One quick detail',
                            hint: quickHint()
                        }

                    case 'delivery_concern':
                        return {
                            title: 'Delivery Concern',
                            hint: "What is your concern related to the delivery?"
                        }

                    case 'cancel_concern':
                        return {
                            title: 'Cancellation',
                            hint: "What is your concern related to the order?"
                        }

                    case 'changes_concern':
                        return {
                            title: 'Changes',
                            hint: "What changes would you like to make to your order?"
                        }

                    case 'damage_concern':
                        return {
                            title: 'Damage',
                            hint: "What items were damaged and how did it happen? Was the box damaged as well? (provide as many details as you can so we can investigate)"
                        }

                    case 'general_concern':
                        return {
                            title: 'General Concern',
                            hint: 'Hi what questions do you have?',
                        }

                    case 'general_email':
                        return {
                            title: 'How should we contact you?',
                            hint: 'What is your email?',
                        }

                    case 'damage_upload':
                        return {
                            title: 'Damage',
                            hint: "Please upload a photo of the damaged items and/or packaging. We accept .jpg and .png files. Note: This is a mandatory step."
                        }

                    case 'cancel_order':
                        return {
                            title: "Cancel Order",
                            hint: "What changes would you like to make to your order?"
                        }

                    case 'order_confirmation':
                        return {
                            title: "Let's find your order first.",
                            hint: "Do you know your order number?"
                        }

                    case 'order_confirmation_delivery':
                        return {
                            title: "Let's find your order first.",
                            hint: "Do you know your order number?"
                        }

                    case 'order_confirmation_cancel':
                        return {
                            title: "Let's find your order first.",
                            hint: "Do you know your order number?"
                        }

                    case 'order_confirmation_changes':
                        return {
                            title: "Let's find your order first.",
                            hint: "Do you know your order number?"
                        }

                    case 'order_confirmation_damage':
                        return {
                            title: "Let's find your order first.",
                            hint: "Do you know your order number?"
                        }

                    case 'order_gate':
                        return {
                            title: '',
                            hint: ''
                        }
// Let’s connect this to your order
// Enter your Order Number.
                    case 'order_lookup':
                        return {
                            title: "Let's find your order first.",
                            hint: 'Enter your Email Address and Postal Code.'
                        }

                    case 'order_fields':
                        return {
                            title: isOrderRelated(state.issue_type)
                                ? 'Provide order details'
                                : 'How should we contact you?',
                            hint: isOrderRelated(state.issue_type)
                                ? state.has_order_number
                                    ? 'Enter your order number and confirm your email.'
                                    : 'Enter your email and postal code to find the order.'
                                : 'Enter your email so we can respond.'
                        }

                    case 'message':
                        return {
                            title: 'Describe the issue',
                            hint: 'A few details help us resolve this faster.'
                        }

                    case 'submit':
                        return {
                            title: 'Ready to submit',
                            hint: 'Submit your request or chat with an agent if available.'
                        }

                    case 'fallback_message':
                        return {
                            title: 'Ask a question',
                            hint: 'You can send a request or chat with us.'
                        }

                    case 'thank_you':
                        return {
                            title: 'Thank You',
                            hint: 'Thank you for your inquiry and shopping with us!.'
                        }

                    default:
                        return {title: '', hint: ''}
                }
            }

            function renderTrackingModal() {
                const overlay = el('div', {class: 'sw-modal1-overlay'})

                overlay.onclick = () => {
                    state.tracking_modal_open = false
                    render()
                }

                // state.tracking_order

                console.log("TRACKINGORDER: ", state.tracking_order)

                const modal = el('div', {class: 'sw-modal1'})

                modal.onclick = e => e.stopPropagation()

                const headerText = "Order: " + state.tracking_order.order_number

                const header = el('div', {class: 'sw-modal1-header'}, [
                    el('div', {class: 'sw-modal1-title', text: headerText})
                ])

                const closeBtn = el('button', {
                    class: 'sw-modal1-close',
                    type: 'button',
                    text: '×'
                })

                closeBtn.onclick = e => {
                    e.stopPropagation()
                    state.tracking_modal_open = false
                    render()
                }

                header.appendChild(closeBtn)
                modal.appendChild(header)

                const bodyWrap = el('div', {class: 'sw-modal1-body split'})

                /* =========================
                  LEFT SIDE – ORDER DETAILS
                ========================= */

                const left = el('div', {class: 'sw-modal1-left'})

                var trackingStatus = state.tracking_order.shipping_status !== "unfulfilled" ? "Shipped" : "Unfulfilled"
                const orderDetails = [
                    {label: 'Bill To', value: state.tracking_order.bill_to},
                    {label: 'Ship To', value: state.tracking_order.ship_to},
                    {label: 'Order Date', value: state.tracking_order.order_date},
                    {label: 'Delivery Date', value: state.tracking_order.delivery_date},
                    {label: 'Shipping Status', value: trackingStatus},
                ]

                orderDetails.forEach(d => {
                    if (!d.value) return

                    const row = el('div', {class: 'sw-detail-row'}, [
                        el('div', {class: 'sw-detail-label', text: d.label}),
                        el('div', {class: 'sw-detail-value', text: d.value})
                    ])

                    left.appendChild(row)
                })

                if (state.tracking_order.tracking_link) {
                    const link = el('a', {
                        class: 'sw-tracking-link',
                        href: state.tracking_order.tracking_link,
                        target: '_blank',
                        text: 'Click here to track your order'
                    })

                    left.appendChild(link)
                }

                /* =========================
                  RIGHT SIDE – TIMELINE
                ========================= */

                const right = el('div', {class: 'sw-modal1-right'})

                const trackingHistory = state.tracking_order.history || []
                const images = state.tracking_order.images || []

                trackingHistory
                    //.slice()
                    //.reverse()
                    .forEach((h, index) => {

                        const item = el('div', {class: 'sw-timeline-item'})

                        const dot = el('div', {
                            class: 'sw-timeline-icon' + (index === 0 ? ' active' : ''),
                            html: historyIcon
                        })

                        const timelineTitle = h.title ? h.title : h.description;
                        const time = h.time ? h.time : h.creation_date;
                        const location = h.location ? h.location : ""
                        const content = el('div', {class: 'sw-timeline-content'}, [
                            el('div', {class: 'sw-timeline-title', text: timelineTitle}),
                            el('div', {
                                class: 'sw-timeline-meta',
                                //text: `${location} • ${time}`
                                text: `${time}`
                            })
                        ])

                        item.appendChild(dot)
                        item.appendChild(content)
                        right.appendChild(item)
                    })

                const historyImages = el('div', {class: 'sw-images-delivery'});
                images
                    .forEach((h, index) => {

                        const itemImage = el('div', {
                            class: 'sw-image-delivery',
                            html: '<img src=' + h + ' width="100%"/>'
                        })

                        historyImages.appendChild(itemImage);
                    })

                //if (images.lenght>0){

                right.appendChild(historyImages);
                //}

                /* ========================= */

                bodyWrap.appendChild(left)
                bodyWrap.appendChild(right)

                // modal.appendChild(bodyWrap)

                modal.appendChild(bodyWrap)
                overlay.appendChild(modal)

                /* =========================
                  FOOTER – FOLLOW UP QUESTION
                ========================= */

                const footer = el('div', {class: 'sw-modal1-footer'})

                const question = el('div', {
                    class: 'sw-followup-text',
                    text: 'This is the status of your order. Do you have any further questions?'
                })

                const btnRow = el('div', {class: 'sw-followup-buttons'})

                const yesBtn = el('button', {
                    class: 'sw-btn-modal1 yes',
                    type: 'button',
                    text: 'Yes'
                })

                const noBtn = el('button', {
                    class: 'sw-btn-modal1 no',
                    type: 'button',
                    text: 'No'
                })

                // yesBtn.onclick = e => {
                //   e.stopPropagation()
                //   state.tracking_modal_open = false
                //   state.active = 'issue'
                //   render()
                // }
                yesBtn.onclick = e => {
                    e.stopPropagation()
                    //resetOrderFlow()
                    state.tracking_modal_open = false
                    // state.active = 'issue'

                    render()
                }

                noBtn.onclick = e => {
                    e.stopPropagation()
                    state.tracking_modal_open = false
                    state.thank_you_switch = true
                    state.active = 'thank_you'
                    render()
                }

                btnRow.appendChild(yesBtn)
                btnRow.appendChild(noBtn)

                if (state.issue_type === "ORDER_STATUS") {
                    footer.appendChild(question)

                    footer.appendChild(btnRow)

                    modal.appendChild(footer)
                }
                return overlay


            }

            // Email verification helper function
            function isValidEmail(email) {
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            }

            function checkValues(value) {
                console.log("CHECKVALUES: ", value)
                return
            }


            function renderIssue() {
                const rail = el('div', {class: 'sw-rail'})

                // Compute which card should be shown
                const activeId = state.active
                // state.active = activeId;

                // Render only the active card
                let cardToRender = null;
                console.log('start renderIssue');
                cardToRender = card({
                    id: 'issue',
                    title: 'What can we help you with today?',
                    hint: 'Choose one option to begin.',
                    mini: state.issue_type
                        ? `Selected: ${labelForIssue(state.issue_type)}`
                        : '',
                    controls: ctl => {
                        ctl.appendChild(
                            chips(
                                ISSUE,
                                state.issue_type,
                                v => {
                                    resetOrderFlow();
                                    if (v === 'LIVECHAT') {
                                        liveAgentOpenChat({containerEl: null, prefill: {}})
                                        document.getElementById('sw-overlay')?.remove()
                                        document.getElementById('sw-fab').style.display = ''
                                        return
                                    }


                                    state.issue_type = v
                                    state.recipient_received = ''
                                    state.damage_subtype = ''
                                    state.change_request_type = ''
                                    state.refund_reason = ''
                                    state.email = ''
                                    state.order_number = ''
                                    state.postal_code = ''
                                    state.order_found = null
                                    state.has_order_number = null
                                    state.wants_lookup = null
                                    state.message = ''
                                    state.files = []
                                    render()
                                },
                                'tiles'
                            )
                        )
                    }
                })
                return cardToRender;
            }

            function renderQuick() {
                const rail = el('div', {class: 'sw-rail'})

                // Compute which card should be shown
                const activeId = state.active
                // state.active = activeId;

                // Render only the active card
                let cardToRender = null;

                console.log('start renderQuick');
                cardToRender = card({
                    id: 'quick',
                    title: '',
                    hint: quickHint(),
                    mini: quickMini(),
                    controls: ctl => {
                        //hereee
                        if (state.issue_type === 'DAMAGE') {
                            ctl.appendChild(
                                chips(
                                    DAMAGE_SUBTYPES,
                                    state.damage_subtype,
                                    v => {
                                        state.damage_subtype = v
                                        checkValues(state.damage_subtype)
                                        //hereee
                                        render()
                                    },
                                    'pills'
                                )
                            )
                        } else if (state.issue_type === 'CHANGES') {
                            ctl.appendChild(
                                chips(
                                    CHANGE_TYPES,
                                    state.change_request_type,
                                    v => {
                                        state.change_request_type = v
                                        //checkValues(state.change_request_type)
                                        state.active='quick';//changes_concern';
                                        render()
                                    },
                                    'pills'
                                )
                            )
                        } else if (state.issue_type === 'BILLING') {
                            ctl.appendChild(
                                chips(
                                    REFUND_REASONS,
                                    state.refund_reason,
                                    v => {
                                        state.refund_reason = v
                                        checkValues(state.refund_reason)
                                        render()
                                    },
                                    'pills'
                                )
                            )
                        } else {
                            ctl.appendChild(
                                el(
                                    'div',
                                    {
                                        class: 'sw-hint',
                                        text: 'No extra details needed for this request type.'
                                    },
                                    'pills'
                                )
                            )
                        }
                    }

                });
                return cardToRender;
            }

            function renderRail() {
                const rail = el('div', {class: 'sw-rail'})

                // Compute which card should be shown
                const activeId = state.active
                // state.active = activeId;

                // Render only the active card
                let cardToRender = null;

                console.log('activeId', activeId);

                switch (activeId) {
                    case 'issue':
                        cardToRender = renderIssue();
                        break

                    case 'quick':
                        // One quick detail (helps us resolve this faster)
                        cardToRender = renderQuick();
                        break

                    case 'order_confirmation':
                        console.log('start order_confirmation');
                        cardToRender = card({
                            id: "order_confirmation",
                            title: "Let's track your order.",
                            hint: "Do you know your order number?",
                            controls: (ctl) => {
                                ctl.appendChild(chips([{id: true, label: "Yes"}, {
                                    id: false,
                                    label: "No, help me find it"
                                }], state.has_order_number, (v) => {

                                    ////here
                                    state.has_order_number = (v === true || v === "true");
                                    //hereeeeee
                                    // reset fields for chosen path
                                    state.order_number = "";
                                    state.postal_code = "";
                                    state.order_found = null;
                                    render();
                                }));
                            }
                        })
                        break

                    case 'order_confirmation_delivery':
                        console.log('start order_confirmation_delivery');
                        cardToRender = card({
                            id: "order_confirmation_delivery",
                            title: "Let's find your order.",
                            hint: "Do you know your order number?",
                            controls: (ctl) => {
                                // state.has_order_number = null
                                ctl.appendChild(chips([{id: true, label: "Yes"}, {
                                    id: false,
                                    label: "No, help me find it"
                                }], state.has_order_number, (v) => {

                                    state.has_order_number = (v === true || v === "true");
                                    if (!state.has_order_number)
                                        state.help_mode = true;

                                    state.orders = [];

                                    ////here
                                    //state.has_order_number = (v === true || v === "true");
                                    // reset fields for chosen path
                                    state.order_number = "";
                                    state.postal_code = "";
                                    state.order_found = null;
                                    render();
                                }));
                            }
                        })
                        break

                    case 'order_confirmation_changes':
                        console.log('start order_confirmation_changes');
                        cardToRender = card({
                            id: "order_confirmation_changes",
                            title: "Let's find your order.",
                            hint: "Do you know your order number?",
                            controls: (ctl) => {
                                // state.has_order_number = null
                                ctl.appendChild(chips([{id: true, label: "Yes"}, {
                                    id: false,
                                    label: "No, help me find it"
                                }], state.has_order_number, (v) => {

                                    ////here
                                    state.has_order_number = (v === true || v === "true");
                                    if (!state.has_order_number)
                                        state.help_mode = true;

                                    state.orders = [];
                                    // reset fields for chosen path
                                    state.order_number = "";
                                    state.postal_code = "";
                                    state.order_found = null;
                                    render();
                                }));
                            }
                        })
                        break

                    case 'order_confirmation_cancel':
                        console.log('start order_confirmation_cancel');
                        cardToRender = card({
                            id: "order_confirmation_cancel",
                            title: "Let's find your order.",
                            hint: "Do you know your order number?",
                            controls: (ctl) => {
                                // state.has_order_number = null
                                ctl.appendChild(chips([{id: true, label: "Yes"}, {
                                    id: false,
                                    label: "No, help me find it"
                                }], state.has_order_number, (v) => {

                                    ////here
                                    //state.has_order_number = (v === true || v === "true");

                                    state.has_order_number = (v === true || v === "true");
                                    if (!state.has_order_number)
                                        state.help_mode = true;

                                    state.orders = [];

                                    // reset fields for chosen path
                                    state.order_number = "";
                                    state.postal_code = "";
                                    state.order_found = null;
                                    render();
                                }));
                            }
                        })
                        break

                    case 'order_confirmation_damage':
                        console.log('start order_confirmation_damage');
                        cardToRender = card({
                            id: "order_confirmation_damage",
                            title: "Let's find your order.",
                            hint: "Do you know your order number?",
                            controls: (ctl) => {
                                // state.has_order_number = null
                                ctl.appendChild(chips([{id: true, label: "Yes"}, {
                                    id: false,
                                    label: "No, help me find it"
                                }], state.has_order_number, (v) => {


                                    //help_mode
                                    console.log('order_confirmation_damage', activeId, v);
                                    ////here
                                    state.has_order_number = (v === true || v === "true");
                                    if (!state.has_order_number) {
                                        state.help_mode = true;
                                    }
                                    state.orders = [];
                                    // reset fields for chosen path
                                    state.order_number = "";
                                    state.postal_code = "";
                                    state.order_found = null;
                                    render();
                                }));
                            }
                        })
                        break

                    case 'order_gate':
                        console.log('start order_gate');
                        cardToRender = card({
                            id: 'order_gate',
                            title: 'Provide order details',
                            hint: 'Enter your order number to verify your purchase.',
                            controls: ctl => {
                                state.showOnlineChatOnBack=false;
                                //console.log('Provide order details order_confirmation_damage', state);
                                // const orderField = el('div', { class: 'sw-field' })

                                // const orderLabel = el('label', {
                                //   class: 'sw-label',
                                //   text: 'Order number'
                                // })

                                // const order = el('input', {
                                //   class: 'sw-input',
                                //   type: 'text',
                                //   value: state.order_number || ''
                                // })

                                // orderField.appendChild(orderLabel)
                                // orderField.appendChild(order)
                                // ctl.appendChild(orderField)

                                // order.oninput = e => {
                                //   state.order_number = e.target.value
                                // }
                                const orderForm = el('div', {class: 'sw-findorder'})
                                const customerNameField = el('div', {class: 'sw-field'})

                                const customerNameLabel = el('label', {
                                    class: 'sw-label',
                                    text: 'What is your name?'
                                })

                                const customerName = el('input', {
                                    class: 'sw-input',
                                    type: 'text',
                                    value: state.customerName || ''
                                })

                                customerName.oninput = e => {
                                    state.customerName = e.target.value
                                }

                                customerNameField.appendChild(customerNameLabel)
                                customerNameField.appendChild(customerName)

                                orderForm.appendChild(customerNameField);
                                
                                


                                const emailField = el('div', {class: 'sw-field'})

                                const emailLabel = el('label', {
                                    class: 'sw-label',
                                    text: 'What is your e-mail address?'
                                })

                                const email = el('input', {
                                    class: 'sw-input',
                                    type: 'text',
                                    value: state.email || ''
                                })

                                email.oninput = e => {
                                    state.email = e.target.value
                                }

                                emailField.appendChild(emailLabel)
                                emailField.appendChild(email)

                                orderForm.appendChild(emailField)
                                if (!state.help_mode) {
                                    const orderField = el('div', {class: 'sw-field'})

                                    const orderLabel = el('label', {
                                        class: 'sw-label',
                                        text: 'What is your order number?'
                                    })

                                    const order = el('input', {
                                        class: 'sw-input',
                                        type: 'text',
                                        value: state.order_number || ''
                                    })

                                    orderField.appendChild(orderLabel)
                                    orderField.appendChild(order)

                                    order.oninput = e => {
                                        state.postal_code = ""
                                        state.order_number = e.target.value
                                    }

                                    orderForm.appendChild(orderField)

                                } else {
                                    const postalField = el('div', {class: 'sw-field'})

                                    const postalLabel = el('label', {
                                        class: 'sw-label',
                                        text: 'What is your postal code?'
                                    })

                                    const postal = el('input', {
                                        class: 'sw-input',
                                        type: 'text',
                                        value: state.postal_code || ''
                                    })

                                    postalField.appendChild(postalLabel)
                                    postalField.appendChild(postal)

                                    postal.oninput = e => {
                                        state.postal_code = e.target.value
                                        state.order_number = ""
                                    }

                                    orderForm.appendChild(postalField)
                                }


                                
                                const row = el('div', {class: 'sw-row between'})
                                const row1 = el('div', {class: 'sw-row between'})
                                const row2 = el('div', {class: 'sw-row between submit-ticket'})

                                // HELP ME FIND IT
                                const helpBtn = el('button', {
                                    class: 'sw-btn ghost helpmefind',
                                    type: 'button',
                                    text: state.help_mode
                                        ? 'Use order number instead'
                                        : 'Help me find the order'
                                })

                                helpBtn.onclick = e => {
                                    state.lock_step = 'order_gate';
                                    state.active = "order_gate";
                                    //console.log('state helpBtn click', activeId, state);
                                    console.log('order_confirmation_damage helpBtn', activeId, state);
                                    e.stopPropagation()
                                    state.help_mode = !state.help_mode
                                    render()
                                }

                                // VERIFY ORDER
                                const verify = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: state.lookup_status === 'loading'
                                        ? 'Searching...'
                                        : state.help_mode
                                            ? 'Find order'
                                            : 'Confirm order'
                                })


                                //if (state.issue_type==='DAMAGE') {

                                const st = el('div', {
                                    class: 'sw-status',
                                    text: state.verify_status?.text || ''
                                })
                                let result = ''
                                const cancelOrderMessage = el('div', {class: 'sw-row error-message'});
                                verify.onclick = async e => {

                                    e.stopPropagation()
                                    state.tracking_modal_first_open = false


                                    cancelOrderMessage.innerHTML='';
                                    state.lookup_status = 'loading'

                                    const emailValue = (state.email || "").trim();

                                    // check empty value for email field
                                    if (!emailValue) {
                                        state.verify_status = {
                                            text: "Please provide your email address",
                                            color: "red"
                                        };
                                        if (state.verify_status?.color) {
                                            st.style.color = state.verify_status.color
                                        }
                                        state.lookup_status = 'failed'
                                        render();
                                        return;
                                    }

                                    if (state.help_mode===true)
                                    {
                                        const postalCodeValue = (state.postal_code || "").trim();

                                        // check empty value for email field
                                        if (!postalCodeValue) {
                                            state.verify_status = {
                                                text: "Please provide the postal code to help to find your order",//order number so we can better assist you"//Please provide your email address so we can contact you",
                                                color: "red"
                                            };
                                            if (state.verify_status?.color) {
                                                st.style.color = state.verify_status.color
                                            }
                                            state.lookup_status = 'failed'
                                            render();
                                            return;
                                        }
                                    }
                                    if (state.help_mode===false) {
                                        const orderNumberValue = (state.order_number || "").trim();

                                        // check empty value for email field
                                        if (!orderNumberValue) {
                                            state.lookup_status = 'failed'
                                            state.verify_status = {
                                                text: "Please provide the order number",//Please provide your email address so we can contact you",
                                                color: "red"
                                            };
                                            if (state.verify_status?.color) {
                                                st.style.color = state.verify_status.color
                                            }
                                            render();
                                            return;
                                        }
                                    }

                                    render()
                                    // let result = ''

                                    const result = await lookupOrder(
                                        state.email,
                                        state.postal_code,
                                        state.order_number
                                    )
                                    //////
                                    checkValues(result)

                                    if (result === 'success') {
                                        state.lookup_status = 'success'
                                        state.lock_step = 'order_gate'
                                        state.verify_status = null
                                    } else if (result === 'empty') {
                                        state.verify_status = {
                                            text: 'Order was not found.',// Search by postal code.
                                            color: 'red'
                                        }
                                        state.lookup_status = 'failed'        // ✅ stop loading

                                        // setTimeout(() => {
                                        //     state.help_mode = true
                                        //     render()
                                        // }, 5000)

                                    } else if (result === "failed") {
                                        setTimeout(() => {
                                            state.help_mode = true
                                        }, 5000)
                                        state.verify_status = {
                                            text: 'Error in finding the order.',
                                            color: 'red'
                                        }
                                        state.lookup_status = 'failed'        // ✅ stop loading

                                        // setTimeout(() => {
                                        //     state.help_mode = true
                                        //     render()
                                        // }, 5000)
                                    }
                                    render()
                                }

                                    //orderForm.appendChild(postalField)

                                if (state.lookup_status === 'success') {
                                    st.style.cursor = 'pointer'

                                    st.onclick = e => {
                                        e.stopPropagation()
                                        state.tracking_modal_open = true
                                        render()
                                    }
                                }

                                //  console.log('state before:',state);
                                if (
                                    state.lookup_status === 'success' &&
                                    state.orders.length === 1 &&
                                    state.tracking_modal_open === false &&
                                    state.tracking_modal_first_open === false &&
                                    state.delivery_issue === "" &&
                                    state.cancel_request === "" &&
                                    state.changes_request === "" &&
                                    state.damage_issue === ""
                                ) {
                                    state.tracking_order = state.orders[0]
                                    if (state.issue_type === "ORDER_STATUS") {
                                        state.tracking_modal_open = true
                                    }

                                    state.tracking_modal_first_open = true
                                }
                                //  console.log('state after:',state);
                                if (state.orders.length > 0) {

                                    orderForm.classList.add('hide');
                                    const returnFindOrder=el('div', {class: 'sw-show-find-order'});

                                     const returnFindOrderButton = document.createElement('button');
                                                returnFindOrderButton.textContent = "Click here, to find another order";
                                                returnFindOrderButton.className = "sw-show-find-order";

                                                returnFindOrderButton.onclick = e => {
                                                    orderForm.classList.remove('hide');
                                                    state.orders=[];
                                                    render();
                                                };

                                    returnFindOrder.appendChild(returnFindOrderButton)
                                    ctl.appendChild(returnFindOrder)
                                

                                    const table = document.createElement('table');
                                    // table.classList.add('table1');
                                    ////hereee
                                    // Header
                                    const headerRow = document.createElement('tr');

                                    headerRow.classList.add('table-header');
                                    headerRow.innerHTML = `
                                      <th>Order #</th>
                                      <th>Order Date</th>
                                      <th></th>
                                    `;
                                    table.appendChild(headerRow);

                                    if (state.issue_type === "ORDER_STATUS") {

                                        state.orders.forEach((_order) => {

                                            const tr = document.createElement('tr');

                                            // Order number
                                            const tdOrder = document.createElement('td');
                                            tdOrder.textContent = _order.order_number;

                                            // Details button
                                            const tdButton = document.createElement('td');
                                            const btn = document.createElement('button');
                                            btn.textContent = "Details";
                                            btn.className = "details-btn";

                                            // st.onclick = e => {
                                            btn.onclick = e => {
                                                // openModal(_order);
                                                // overlay.renderTrackingModal(_order)

                                                e.stopPropagation()
                                                state.order_number = String(_order.order_number || '').replace('#', '')
                                                state.order_found = _order;
                                                //state.order_number=_order.order_number;
                                                state.tracking_order = _order
                                                state.tracking_modal_open = true
                                                render()
                                            };
                                            tdButton.appendChild(btn);

                                            // Shipping status
                                            const tdStatus = document.createElement('td');
                                            tdStatus.textContent = _order.order_date;

                                            tr.appendChild(tdOrder);
                                            tr.appendChild(tdStatus);
                                            tr.appendChild(tdButton);

                                            table.appendChild(tr);
                                        });

                                        const foundedOrders = el('div', {
                                            class: 'sw-orders'
                                        });

                                        foundedOrders.appendChild(table);
                                        row1.appendChild(foundedOrders);
                                    } else {
                                        state.orders.forEach((_order) => {

                                            const tr = document.createElement('tr');

                                            const fulfilledStatus=_order.tracking_number;
                                            if (state.issue_type==='CANCEL') {
                                                if (fulfilledStatus !== '')
                                                    state.orderAlreadyFulfilled = true;
                                                else state.orderAlreadyFulfilled=false;
                                            }else
                                                state.orderAlreadyFulfilled=false;



                                            // Order number
                                            const tdOrder = document.createElement('td');
                                            tdOrder.textContent = _order.order_number;

                                            // Details button
                                            const tdButton = document.createElement('td');

                                            if (!state.orderAlreadyFulfilled) {

                                                const btn = document.createElement('button');
                                                btn.textContent = "Confirmed";
                                                btn.className = "details-btn";

                                                // st.onclick = e => {
                                                btn.onclick = e => {
                                                    // openModal(_order);
                                                    // overlay.renderTrackingModal(_order)

                                                    // e.stopPropagation()
                                                    // state.tracking_order = _order
                                                    // state.tracking_modal_open = true
                                                    // render()

                                                    e.stopPropagation();
                                                    //state.lock_step=null;
                                                    state.order_back = true;
                                                    const emailValue = (state.email || "").trim();

                                                    // check empty value for email field
                                                    if (!emailValue) {
                                                        state.verify_status = {
                                                            text: "Email is required before contacting support.",
                                                            color: "red"
                                                        };
                                                        render();
                                                        return;
                                                    }


                                                    // if (!state.message) {
                                                    //   state.message = "Customer contacted support without order verification.";
                                                    // }
                                                    state.lock_step = null;
                                                    state.show_history = false;

                                                    state.order_number = String(_order.order_number || '').replace('#', '')
                                                    state.order_found = _order;

                                                    if (state.issue_type === 'DELIVERY')
                                                        state.active = "delivery_concern";
                                                    else if (state.issue_type === 'DAMAGE')
                                                        state.active = "damage_concern";
                                                    else if (state.issue_type === 'CHANGES')
                                                        state.active = "quick";
                                                        //state.active = "changes_concern";
                                                    else if (state.issue_type === 'CANCEL')
                                                        state.active = "cancel_concern";

                                                    state.fromBack = true;
                                                    render();
                                                };
                                                tdButton.appendChild(btn);
                                            }else{

                                            }

                                            // Shipping status
                                            const tdStatus = document.createElement('td');
                                            tdStatus.textContent = _order.order_date;

                                            tr.appendChild(tdOrder);
                                            tr.appendChild(tdStatus);
                                            tr.appendChild(tdButton);

                                            table.appendChild(tr);
                                        });

                                        const foundedOrders = el('div', {
                                            class: 'sw-orders'
                                        });

                                        foundedOrders.appendChild(table);
                                        row1.appendChild(foundedOrders);
                                        if (state.orders.length===1){
                                            if (state.issue_type==='CANCEL') {

                                                if (state.orderAlreadyFulfilled) {
                                                    cancelOrderMessage.innerHTML = "Your order has been fulfilled. Typically, we are unable to cancel an order once it has been shipped. if you require further assistance, please submit a request to customer service for available options";
                                                }

                                            }
                                        }

                                    }

                                   

                                    if (cancelOrderMessage.innerHTML!=='')
                                        row1.appendChild(cancelOrderMessage);







                                    const swBackRow = document.querySelector('.sw-back-row');

                                    //state.showOnlineChatOnBack=true;


                                    if (state.verify_status?.color) {
                                        st.style.color = state.verify_status.color
                                    }
                                    /*var textCreateTicket = "Submit Ticket";

                                    if (state.issue_type === 'DELIVERY')
                                        textCreateTicket = 'Add delivery concern';
                                    else if (state.issue_type === 'DAMAGE')
                                        textCreateTicket = 'Add damage concern';
                                    else if (state.issue_type === 'CHANGES')
                                        textCreateTicket = 'Add changes concern';
                                    else if (state.issue_type === 'CANCEL')
                                        textCreateTicket = 'Add cancel concern';

                                    const createTicket = el("button", {
                                        class: "sw-btn ghost",
                                        type: "button",
                                        text: textCreateTicket
                                    });
                                    if (state.issue_type === 'CHANGES') {
                                        createTicket.onclick = async (e) => {
                                            e.stopPropagation();
                                            //state.lock_step=null;
                                            state.order_back = true;
                                            const emailValue = (state.email || "").trim();

                                            // check empty value for email field
                                            if (!emailValue) {
                                                state.verify_status = {
                                                    text: "Email is required before contacting support.",
                                                    color: "red"
                                                };
                                                render();
                                                return;
                                            }


                                            // if (!state.message) {
                                            //   state.message = "Customer contacted support without order verification.";
                                            // }
                                            state.lock_step = null;
                                            state.show_history = false;
                                            state.active = "changes_concern";
                                            state.fromBack = true;
                                            render();
                                        };
                                    } else if (state.issue_type === 'CANCEL') {
                                        createTicket.onclick = async (e) => {
                                            e.stopPropagation();
                                            //state.lock_step=null;
                                            state.order_back = true;
                                            const emailValue = (state.email || "").trim();

                                            // check empty value for email field
                                            if (!emailValue) {
                                                state.verify_status = {
                                                    text: "Email is required before contacting support.",
                                                    color: "red"
                                                };
                                                render();
                                                return;
                                            }


                                            // if (!state.message) {
                                            //   state.message = "Customer contacted support without order verification.";
                                            // }
                                            state.lock_step = null;
                                            state.show_history = false;
                                            state.active = "cancel_concern";
                                            state.fromBack = true;
                                            render();
                                        };
                                    } else if (state.issue_type === 'DELIVERY') {
                                        createTicket.onclick = async (e) => {
                                            e.stopPropagation();
                                            //state.lock_step=null;
                                            state.order_back = true;
                                            const emailValue = (state.email || "").trim();

                                            // check empty value for email field
                                            if (!emailValue) {
                                                state.verify_status = {
                                                    text: "Email is required before contacting support.",
                                                    color: "red"
                                                };
                                                render();
                                                return;
                                            }


                                            // if (!state.message) {
                                            //   state.message = "Customer contacted support without order verification.";
                                            // }
                                            state.lock_step = null;
                                            state.show_history = false;
                                            state.active = "delivery_concern";
                                            state.fromBack = true;
                                            render();
                                        };
                                    }
                                    //order_confirmation_delivery
                                    else if (state.issue_type === 'DAMAGE') {
                                        createTicket.onclick = async (e) => {
                                            e.stopPropagation();
                                            //state.lock_step=null;
                                            state.order_back = true;
                                            const emailValue = (state.email || "").trim();

                                            // check empty value for email field
                                            if (!emailValue) {
                                                state.verify_status = {
                                                    text: "Email is required before contacting support.",
                                                    color: "red"
                                                };
                                                render();
                                                return;
                                            }


                                            // if (!state.message) {
                                            //   state.message = "Customer contacted support without order verification.";
                                            // }
                                            state.lock_step = null;
                                            state.show_history = false;
                                            state.active = "damage_concern";
                                            state.fromBack = true;
                                            render();
                                        };
                                    } else {
    */
                                    if ((state.issue_type !== 'DELIVERY') &&
                                        (state.issue_type !== 'DAMAGE') &&
                                        (state.issue_type !== 'CHANGES') &&
                                        (state.issue_type !== 'CANCEL')) {

                                        var textCreateTicket = "Submit Ticket";

                                        const createTicket = el("button", {
                                            class: "sw-btn ghost",
                                            type: "button",
                                            text: textCreateTicket
                                        });
                                        createTicket.onclick = async (e) => {
                                            e.stopPropagation();
                                            //state.lock_step=null;
                                            state.order_back = true;
                                            const emailValue = (state.email || "").trim();

                                            // check empty value for email field
                                            if (!emailValue) {
                                                state.verify_status = {
                                                    text: "Email is required before contacting support.",
                                                    color: "red"
                                                };
                                                render();
                                                return;
                                            }

                                            if (Array.isArray(state.orders) && state.orders.length > 0) {
                                                const orders = state.orders;
                                                orders.forEach(order => {
                                                    let msg = "";//Customer contacted support with order verification\n";
                                                    //msg += "============================================================\n\n";

                                                    state.orders.forEach((order, index) => {
                                                        //msg += `Order ${index + 1}\n`;
                                                        //msg += `-----------\n`;
                                                        //msg += `Order Number : ${order.order_number}\n`;
                                                        msg += `Customer Email : ${state.email}\n`;
                                                        msg += `Bill To : ${order.bill_to}\n`;
                                                        msg += `Shipping Status : ${order.shipping_status}\n`;
                                                        msg += `Payment Status: ${order.payment_status}\n`;
                                                        msg += `Payment Method: ${order.payment_method}\n`;
                                                        if (order.shipping_status !== 'unfulfilled' && order.tracking_number != '') {
                                                            msg += `Tracking number : ${order.tracking_number}\n`;
                                                        }

                                                        if (order.tracking_number) {
                                                            //msg += `Tracking Number : ${order.tracking_number}\n`;
                                                            msg += `Tracking Link : ${order.tracking_link}\n`;
                                                        }

                                                        // msg += "\n"; // space between orders
                                                    });

                                                    state.liveAgentMessage = msg;

                                                });
                                                let stateMessage = '';
                                                if (state.issue_type) {
                                                    stateMessage += `Issue Type : ${state.issue_type}\n`;
                                                }
                                                if (state.delivery_issue) {
                                                    stateMessage += `Delivery Issue : ${state.delivery_issue}\n`;
                                                }
                                                if (state.cancel_request) {
                                                    stateMessage += `Reason to Cancel : ${state.cancel_request}\n`;
                                                }
                                                if (state.changes_request) {
                                                    stateMessage += `Changes : ${state.changes_request}\n`;
                                                }
                                                if (state.damage_issue) {
                                                    stateMessage += `Damage  : ${state.damage_issue}\n`;
                                                }
                                                // if(state.issue_type && state.damage_subtype!='' && state.damage_subtype!==null && state.damage_subtype!==undefined) {
                                                //   stateMessage += `Damage Type : ${state.damage_subtype}\n`;
                                                // }

                                                if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                                    stateMessage += `Order number : ${state.order_number}\n`;
                                                }

                                                //state.liveAgentMessage = stateMessage //Issue type message will set to LiveAgentMeesage

                                            } else {
                                                state.liveAgentMessage = "Customer contacted support without order verification.";
                                            }

                                            // if (!state.message) {
                                            //   state.message = "Customer contacted support without order verification.";
                                            // }
                                            state.lock_step = null;
                                            state.show_history = false;
                                            state.active = "fallback_message";
                                            state.fromBack = true;
                                            render();
                                        };

                                        if (state.issue_type !== "ORDER_STATUS") {
                                            if (state.lookup_status === 'success') {
                                                row2.appendChild(createTicket) // appending submit ticket button
                                            }
                                        }
                                    }
                                    //}
                                }
                                
                                row.appendChild(verify)   // LEFT
                                row.appendChild(helpBtn)  // RIGHT

                                row1.appendChild(st)

                                orderForm.appendChild(row)
                                ctl.appendChild(row1)

                                

                                ctl.appendChild(orderForm)
                                ctl.appendChild(row2) //submit ticket button

                            }
                        })
                        break

                    case 'order_lookup':
                        console.log('start order_lookup');
                        cardToRender = card({
                            id: 'order_lookup',
                            title: 'Help me find your order',
                            hint: 'Enter the email and postal code used at checkout.',
                            controls: ctl => {
                                state.showOnlineChatOnBack=true;

                                // EMAIL
                                const emailInput = el('input', {
                                    class: 'sw-input',
                                    type: 'email',
                                    placeholder: 'Email address',
                                    value: state.email || ''
                                })

                                emailInput.oninput = e => {
                                    state.email = e.target.value
                                }

                                // POSTAL CODE
                                const postalInput = el('input', {
                                    class: 'sw-input',
                                    type: 'text',
                                    placeholder: 'Postal code',
                                    value: state.postal_code || ''
                                })

                                postalInput.oninput = e => {
                                    state.postal_code = e.target.value
                                }

                                ctl.appendChild(emailInput)
                                ctl.appendChild(postalInput)

                                const row = el('div', {class: 'sw-row between'})

                                // BACK
                                const backBtn = el('button', {
                                    class: 'sw-btn ghost',
                                    type: 'button',
                                    text: '← Back'
                                })

                                backBtn.onclick = () => {
                                    state.active = 'order_gate'
                                    render()
                                }

                                // FIND ORDER
                                const findBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: state.lookup_status === 'loading'
                                        ? 'Searching...'
                                        : 'Find order'
                                })

                                findBtn.disabled = !state.email || !state.postal_code

                                findBtn.onclick = async () => {
                                    state.lookup_status = 'loading'
                                    render()

                                    try {
                                        // your lookup API call here

                                        state.lookup_status = 'success'
                                        render()

                                    } catch (err) {
                                        state.lookup_status = 'error'
                                        render()
                                    }
                                }

                                row.appendChild(backBtn)
                                row.appendChild(findBtn)

                                ctl.appendChild(row)
                            }
                        })
                        break

                    case 'delivery_concern':
                        console.log('start delivery_concern');
                        cardToRender = card({
                            id: 'delivery_concern',
                            title: 'Delivery Issues',
                            hint: 'What is your concern related to the delivery?',
                            controls: ctl => {
                                state.showOnlineChatOnBack=true;

                                // EMAIL
                                const deliveryInput = el('textarea', {
                                    class: 'sw-input',
                                    placeholder: 'Your Delivery Issues',
                                    value: state.delivery_issue || ''
                                })
                                ////herree


                                const row = el('div', {class: 'sw-row sw-row-send-request'})

                                // actions row
                                //const row = el('div', {class: 'sw-row'})

                                // live chat button
                                /*const chatBtn = el('button', {
                                    class: 'sw-btn ghost',
                                    type: 'button',
                                    text: 'Chat with us'
                                })
                                chatBtn.onclick = () => {
                                    liveAgentOpenChat({
                                        containerEl: null,
                                        prefill: {
                                            email: state.email,
                                            message: 'Order number: ' + state.order_number + '. Delivery issue:'.state.delivery_issue
                                        }
                                    })
                                }*/

                                // send request button
                                const sendBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Send request'
                                })
                                sendBtn.disabled = !state.delivery_issue || state.delivery_issue.length === 0

                                deliveryInput.oninput = e => {
                                    //state.delivery_issue
                                    console.log('e delivery_issue', e);
                                    state.delivery_issue = e.target.value;
                                    //state.damage_files = validFiles
                                    sendBtn.disabled = state.delivery_issue.length === 0
                                }

                                sendBtn.onclick = () => {
                                    state.fromBack = true


                                    if (Array.isArray(state.orders) && state.orders.length > 0) {
                                        const orders = state.orders;
                                        orders.forEach(order => {
                                            let msg = "";//Customer contacted support with order verification\n";
                                            //msg += "============================================================\n\n";

                                            state.orders.forEach((order, index) => {
                                                //msg += `Order ${index + 1}\n`;
                                                //msg += `-----------\n`;
                                                //msg += `Order Number : ${order.order_number}\n`;
                                                msg += `Customer Email : ${state.email}\n`;
                                                msg += `Bill To : ${order.bill_to}\n`;
                                                msg += `Shipping Status : ${order.shipping_status}\n`;
                                                msg += `Payment Status: ${order.payment_status}\n`;
                                                msg += `Payment Method: ${order.payment_method}\n`;
                                                if (order.shipping_status !== 'unfulfilled' && order.tracking_number != '') {
                                                    msg += `Tracking number : ${order.tracking_number}\n`;
                                                }

                                                if (order.tracking_number) {
                                                    //msg += `Tracking Number : ${order.tracking_number}\n`;
                                                    msg += `Tracking Link : ${order.tracking_link}\n`;
                                                }

                                                // msg += "\n"; // space between orders
                                            });

                                            state.liveAgentMessage = msg;

                                        });
                                        let stateMessage = '';
                                        if (state.issue_type) {
                                            stateMessage += `Issue Type : ${state.issue_type}\n`;
                                        }
                                        if (state.delivery_issue) {
                                            stateMessage += `Delivery Issue : ${state.delivery_issue}\n`;
                                        }
                                        if (state.cancel_request) {
                                            stateMessage += `Reason to Cancel : ${state.cancel_request}\n`;
                                        }
                                        if (state.changes_request) {
                                            stateMessage += `Changes : ${state.changes_request}\n`;
                                        }
                                        if (state.damage_issue) {
                                            stateMessage += `Damage  : ${state.damage_issue}\n`;
                                        }
                                        // if(state.issue_type && state.damage_subtype!='' && state.damage_subtype!==null && state.damage_subtype!==undefined) {
                                        //   stateMessage += `Damage Type : ${state.damage_subtype}\n`;
                                        // }

                                        if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                            stateMessage += `Order number : ${state.order_number}\n`;
                                        }

                                        //state.liveAgentMessage = stateMessage //Issue type message will set to LiveAgentMeesage

                                    } else {
                                        state.liveAgentMessage = "Customer contacted support without order verification.";
                                    }

                                    state.lock_step = null;
                                    state.show_history = false;
                                    state.active = 'submit'
                                    //state.active = "fallback_message";
                                    state.fromBack = true;
                                    //state.active = 'fallback_message';//order_confirmation_damage'
                                    render()
                                }


                                //row.appendChild(chatBtn)
                                row.appendChild(sendBtn)
                                //ctl.appendChild(row)

                                ctl.appendChild(deliveryInput)
                                //row.appendChild(nextBtn)
                                ctl.appendChild(row)


                                /*
                                const row = el('div', {class: 'sw-row between'})

                                // FIND ORDER
                                const nextBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Submit'
                                })

                                // nextBtn.disabled = true
                                nextBtn.disabled = state.delivery_issue === ""

                                deliveryInput.oninput = e => {
                                    state.delivery_issue = e.target.value
                                    nextBtn.disabled = state.delivery_issue === ""
                                }

                                nextBtn.onclick = async () => {
                                    // state.active = 'order_confirmation_delivery'
                                    // render()

                                    if (Array.isArray(state.orders) && state.orders.length > 0) {
                                        const orders = state.orders;
                                        orders.forEach(order => {
                                            let msg = "";//Customer contacted support with order verification\n";
                                            //msg += "============================================================\n\n";

                                            state.orders.forEach((order, index) => {
                                                //msg += `Order ${index + 1}\n`;
                                                //msg += `-----------\n`;
                                                //msg += `Order Number : ${order.order_number}\n`;
                                                msg += `Customer Email : ${state.email}\n`;
                                                msg += `Bill To : ${order.bill_to}\n`;
                                                msg += `Shipping Status : ${order.shipping_status}\n`;
                                                msg += `Payment Status: ${order.payment_status}\n`;
                                                msg += `Payment Method: ${order.payment_method}\n`;
                                                if (order.shipping_status !== 'unfulfilled' && order.tracking_number != '') {
                                                    msg += `Tracking number : ${order.tracking_number}\n`;
                                                }

                                                if (order.tracking_number) {
                                                    //msg += `Tracking Number : ${order.tracking_number}\n`;
                                                    msg += `Tracking Link : ${order.tracking_link}\n`;
                                                }

                                                // msg += "\n"; // space between orders
                                            });

                                            state.liveAgentMessage = msg;

                                        });
                                        let stateMessage = '';
                                        if (state.issue_type) {
                                            stateMessage += `Issue Type : ${state.issue_type}\n`;
                                        }
                                        if (state.delivery_issue) {
                                            stateMessage += `Delivery Issue : ${state.delivery_issue}\n`;
                                        }
                                        if (state.cancel_request) {
                                            stateMessage += `Reason to Cancel : ${state.cancel_request}\n`;
                                        }
                                        if (state.changes_request) {
                                            stateMessage += `Changes : ${state.changes_request}\n`;
                                        }
                                        if (state.damage_issue) {
                                            stateMessage += `Damage  : ${state.damage_issue}\n`;
                                        }
                                        // if(state.issue_type && state.damage_subtype!='' && state.damage_subtype!==null && state.damage_subtype!==undefined) {
                                        //   stateMessage += `Damage Type : ${state.damage_subtype}\n`;
                                        // }

                                        if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                            stateMessage += `Order number : ${state.order_number}\n`;
                                        }

                                        //state.liveAgentMessage = stateMessage //Issue type message will set to LiveAgentMeesage

                                    } else {
                                        state.liveAgentMessage = "Customer contacted support without order verification.";
                                    }

                                    state.lock_step = null;
                                    state.show_history = false;
                                    state.active = "fallback_message";
                                    state.fromBack = true;
                                    //state.active = 'fallback_message';//order_confirmation_damage'
                                    render()
                                }

                                ctl.appendChild(deliveryInput)
                                row.appendChild(el('div')) // spacer
                                row.appendChild(nextBtn)

                                ctl.appendChild(row)*/
                            }
                        })
                        break

                    case 'cancel_concern':
                        console.log('start cancel_concern');
                        cardToRender = card({
                            id: 'cancel_concern',
                            title: 'Cancellation Issues',
                            hint: 'What is your concern related to the order?',
                            controls: ctl => {
state.showOnlineChatOnBack=true;
                                // EMAIL
                                const deliveryInput = el('textarea', {
                                    class: 'sw-input',
                                    placeholder: '',
                                    value: state.cancel_request || ''
                                })
                                ////herree


                                const row = el('div', {class: 'sw-row sw-row-send-request'})

                                // actions row
                                //const row = el('div', {class: 'sw-row'})

                                // live chat button
                                /*const chatBtn = el('button', {
                                    class: 'sw-btn ghost',
                                    type: 'button',
                                    text: 'Chat with us'
                                })
                                chatBtn.onclick = () => {
                                    liveAgentOpenChat({
                                        containerEl: null,
                                        prefill: {
                                            email: state.email,
                                            message: 'Order number: ' + state.order_number + '. Cancel request:'.state.cancel_request
                                            //message: state.changes_request
                                        }
                                    })
                                }*/

                                // send request button
                                const sendBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Send request'
                                })
                                sendBtn.disabled = !state.cancel_request || state.cancel_request.length === 0

                                deliveryInput.oninput = e => {
                                    //state.delivery_issue
                                    console.log('e delivery_issue', e);
                                    state.cancel_request = e.target.value;
                                    //state.damage_files = validFiles
                                    sendBtn.disabled = state.cancel_request.length === 0
                                }

                                sendBtn.onclick = () => {
                                    state.fromBack = true


                                    if (Array.isArray(state.orders) && state.orders.length > 0) {
                                        const orders = state.orders;
                                        orders.forEach(order => {
                                            let msg = "";//Customer contacted support with order verification\n";
                                            //msg += "============================================================\n\n";

                                            state.orders.forEach((order, index) => {
                                                //msg += `Order ${index + 1}\n`;
                                                //msg += `-----------\n`;
                                                //msg += `Order Number : ${order.order_number}\n`;
                                                msg += `Customer Email : ${state.email}\n`;
                                                msg += `Bill To : ${order.bill_to}\n`;
                                                msg += `Shipping Status : ${order.shipping_status}\n`;
                                                msg += `Payment Status: ${order.payment_status}\n`;
                                                msg += `Payment Method: ${order.payment_method}\n`;
                                                if (order.shipping_status !== 'unfulfilled' && order.tracking_number != '') {
                                                    msg += `Tracking number : ${order.tracking_number}\n`;
                                                }

                                                if (order.tracking_number) {
                                                    //msg += `Tracking Number : ${order.tracking_number}\n`;
                                                    msg += `Tracking Link : ${order.tracking_link}\n`;
                                                }

                                                // msg += "\n"; // space between orders
                                            });

                                            state.liveAgentMessage = msg;

                                        });
                                        let stateMessage = '';
                                        if (state.issue_type) {
                                            stateMessage += `Issue Type : ${state.issue_type}\n`;
                                        }
                                        if (state.delivery_issue) {
                                            stateMessage += `Delivery Issue : ${state.delivery_issue}\n`;
                                        }
                                        if (state.cancel_request) {
                                            stateMessage += `Reason to Cancel : ${state.cancel_request}\n`;
                                        }
                                        if (state.changes_request) {
                                            stateMessage += `Changes : ${state.changes_request}\n`;
                                        }
                                        if (state.damage_issue) {
                                            stateMessage += `Damage  : ${state.damage_issue}\n`;
                                        }
                                        // if(state.issue_type && state.damage_subtype!='' && state.damage_subtype!==null && state.damage_subtype!==undefined) {
                                        //   stateMessage += `Damage Type : ${state.damage_subtype}\n`;
                                        // }

                                        if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                            stateMessage += `Order number : ${state.order_number}\n`;
                                        }

                                        //state.liveAgentMessage = stateMessage //Issue type message will set to LiveAgentMeesage

                                    } else {
                                        state.liveAgentMessage = "Customer contacted support without order verification.";
                                    }

                                    state.lock_step = null;
                                    state.show_history = false;
                                    state.active = 'submit'
                                    //state.active = "fallback_message";
                                    state.fromBack = true;
                                    //state.active = 'fallback_message';//order_confirmation_damage'
                                    render()
                                }


                                //row.appendChild(chatBtn)
                                row.appendChild(sendBtn)
                                //ctl.appendChild(row)

                                ctl.appendChild(deliveryInput)
                                //row.appendChild(nextBtn)
                                ctl.appendChild(row)


                                /*
                                const row = el('div', {class: 'sw-row between'})

                                // FIND ORDER
                                const nextBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Submit'
                                })

                                // nextBtn.disabled = true
                                nextBtn.disabled = state.cancel_request === ""

                                deliveryInput.oninput = e => {
                                    state.cancel_request = e.target.value
                                    nextBtn.disabled = state.cancel_request === ""
                                }

                                nextBtn.onclick = async () => {
                                    // state.active = 'order_confirmation_cancel'
                                    // render()

                                    if (Array.isArray(state.orders) && state.orders.length > 0) {
                                        const orders = state.orders;
                                        orders.forEach(order => {
                                            let msg = "";//Customer contacted support with order verification\n";
                                            //msg += "============================================================\n\n";

                                            state.orders.forEach((order, index) => {
                                                //msg += `Order ${index + 1}\n`;
                                                //msg += `-----------\n`;
                                                //msg += `Order Number : ${order.order_number}\n`;
                                                msg += `Customer Email : ${state.email}\n`;
                                                msg += `Bill To : ${order.bill_to}\n`;
                                                msg += `Shipping Status : ${order.shipping_status}\n`;
                                                msg += `Payment Status: ${order.payment_status}\n`;
                                                msg += `Payment Method: ${order.payment_method}\n`;
                                                if (order.shipping_status !== 'unfulfilled' && order.tracking_number != '') {
                                                    msg += `Tracking number : ${order.tracking_number}\n`;
                                                }

                                                if (order.tracking_number) {
                                                    //msg += `Tracking Number : ${order.tracking_number}\n`;
                                                    msg += `Tracking Link : ${order.tracking_link}\n`;
                                                }

                                                // msg += "\n"; // space between orders
                                            });

                                            state.liveAgentMessage = msg;

                                        });
                                        let stateMessage = '';
                                        if (state.issue_type) {
                                            stateMessage += `Issue Type : ${state.issue_type}\n`;
                                        }
                                        if (state.delivery_issue) {
                                            stateMessage += `Delivery Issue : ${state.delivery_issue}\n`;
                                        }
                                        if (state.cancel_request) {
                                            stateMessage += `Reason to Cancel : ${state.cancel_request}\n`;
                                        }
                                        if (state.changes_request) {
                                            stateMessage += `Changes : ${state.changes_request}\n`;
                                        }
                                        if (state.damage_issue) {
                                            stateMessage += `Damage  : ${state.damage_issue}\n`;
                                        }
                                        // if(state.issue_type && state.damage_subtype!='' && state.damage_subtype!==null && state.damage_subtype!==undefined) {
                                        //   stateMessage += `Damage Type : ${state.damage_subtype}\n`;
                                        // }

                                        if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                            stateMessage += `Order number : ${state.order_number}\n`;
                                        }

                                        //state.liveAgentMessage = stateMessage //Issue type message will set to LiveAgentMeesage

                                    } else {
                                        state.liveAgentMessage = "Customer contacted support without order verification.";
                                    }

                                    state.lock_step = null;
                                    state.show_history = false;
                                    state.active = "fallback_message";
                                    state.fromBack = true;
                                    //state.active = 'fallback_message';//order_confirmation_damage'
                                    render()
                                }

                                ctl.appendChild(deliveryInput)
                                row.appendChild(el('div')) // spacer
                                row.appendChild(nextBtn)

                                ctl.appendChild(row)*/
                            }
                        })
                        break
                    case 'changes_concern':
                        console.log('start changes_concern');
                        cardToRender = card({
                            id: 'changes_concern',
                            title: 'Changes',
                            hint: "What changes would you like to make to your order?",
                            controls: ctl => {
state.showOnlineChatOnBack=true;
                                // EMAIL
                                const deliveryInput = el('textarea', {
                                    class: 'sw-input',
                                    placeholder: '',
                                    value: state.changes_request || ''
                                })


                                const row = el('div', {class: 'sw-row sw-row-send-request'})

                                // actions row
                                //const row = el('div', {class: 'sw-row'})

                                // live chat button
                                /*const chatBtn = el('button', {
                                    class: 'sw-btn ghost',
                                    type: 'button',
                                    text: 'Chat with us'
                                })
                                chatBtn.onclick = () => {
                                    liveAgentOpenChat({
                                        containerEl: null,
                                        prefill: {
                                            email: state.email,
                                            message: 'Order number: ' + state.order_number + '. Changes request: '.state.changes_request
                                            //message: state.changes_request
                                        }
                                    })
                                }*/

                                // send request button
                                const sendBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Send request'
                                })
                                sendBtn.disabled = !state.changes_request || state.changes_request.length === 0

                                deliveryInput.oninput = e => {
                                    //state.delivery_issue
                                    console.log('e delivery_issue', e);
                                    state.changes_request = e.target.value;
                                    //state.damage_files = validFiles
                                    sendBtn.disabled = state.changes_request.length === 0
                                }

                                sendBtn.onclick = () => {
                                    state.fromBack = true


                                    if (Array.isArray(state.orders) && state.orders.length > 0) {
                                        const orders = state.orders;
                                        orders.forEach(order => {
                                            let msg = "";//Customer contacted support with order verification\n";
                                            //msg += "============================================================\n\n";

                                            state.orders.forEach((order, index) => {
                                                //msg += `Order ${index + 1}\n`;
                                                //msg += `-----------\n`;
                                                //msg += `Order Number : ${order.order_number}\n`;
                                                msg += `Customer Email : ${state.email}\n`;
                                                msg += `Bill To : ${order.bill_to}\n`;
                                                msg += `Shipping Status : ${order.shipping_status}\n`;
                                                msg += `Payment Status: ${order.payment_status}\n`;
                                                msg += `Payment Method: ${order.payment_method}\n`;
                                                if (order.shipping_status !== 'unfulfilled' && order.tracking_number != '') {
                                                    msg += `Tracking number : ${order.tracking_number}\n`;
                                                }

                                                if (order.tracking_number) {
                                                    //msg += `Tracking Number : ${order.tracking_number}\n`;
                                                    msg += `Tracking Link : ${order.tracking_link}\n`;
                                                }

                                                // msg += "\n"; // space between orders
                                            });

                                            state.liveAgentMessage = msg;

                                        });
                                        let stateMessage = '';
                                        if (state.issue_type) {
                                            stateMessage += `Issue Type : ${state.issue_type}\n`;
                                        }
                                        if (state.delivery_issue) {
                                            stateMessage += `Delivery Issue : ${state.delivery_issue}\n`;
                                        }
                                        if (state.cancel_request) {
                                            stateMessage += `Reason to Cancel : ${state.cancel_request}\n`;
                                        }
                                        if (state.changes_request) {
                                            stateMessage += `Changes : ${state.changes_request}\n`;
                                        }
                                        if (state.damage_issue) {
                                            stateMessage += `Damage  : ${state.damage_issue}\n`;
                                        }
                                        // if(state.issue_type && state.damage_subtype!='' && state.damage_subtype!==null && state.damage_subtype!==undefined) {
                                        //   stateMessage += `Damage Type : ${state.damage_subtype}\n`;
                                        // }

                                        if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                            stateMessage += `Order number : ${state.order_number}\n`;
                                        }

                                        //state.liveAgentMessage = stateMessage //Issue type message will set to LiveAgentMeesage

                                    } else {
                                        state.liveAgentMessage = "Customer contacted support without order verification.";
                                    }

                                    state.lock_step = null;
                                    state.show_history = false;
                                    state.active = 'submit'
                                    //state.active = "fallback_message";
                                    state.fromBack = true;
                                    //state.active = 'fallback_message';//order_confirmation_damage'
                                    render()
                                }


                                //row.appendChild(chatBtn)
                                row.appendChild(sendBtn)
                                //ctl.appendChild(row)

                                ctl.appendChild(deliveryInput)
                                //row.appendChild(nextBtn)
                                ctl.appendChild(row)


                                /*

                                                            const row = el('div', {class: 'sw-row between'})

                                                            // FIND ORDER
                                                            const nextBtn = el('button', {
                                                                class: 'sw-btn primary',
                                                                type: 'button',
                                                                text: 'Submit'
                                                            })

                                                            // nextBtn.disabled = true
                                                            nextBtn.disabled = state.changes_request === ""

                                                            deliveryInput.oninput = e => {
                                                                state.changes_request = e.target.value
                                                                nextBtn.disabled = state.changes_request === ""
                                                            }

                                                            nextBtn.onclick = async () => {
                                                                //state.active = 'order_confirmation_changes'
                                                                //render()
                                                                if (Array.isArray(state.orders) && state.orders.length > 0) {
                                                                    const orders = state.orders;
                                                                    orders.forEach(order => {
                                                                        let msg = "";//Customer contacted support with order verification\n";
                                                                        //msg += "============================================================\n\n";

                                                                        state.orders.forEach((order, index) => {
                                                                            //msg += `Order ${index + 1}\n`;
                                                                            //msg += `-----------\n`;
                                                                            //msg += `Order Number : ${order.order_number}\n`;
                                                                            msg += `Customer Email : ${state.email}\n`;
                                                                            msg += `Bill To : ${order.bill_to}\n`;
                                                                            msg += `Shipping Status : ${order.shipping_status}\n`;
                                                                            msg += `Payment Status: ${order.payment_status}\n`;
                                                                            msg += `Payment Method: ${order.payment_method}\n`;
                                                                            if (order.shipping_status !== 'unfulfilled' && order.tracking_number != '') {
                                                                                msg += `Tracking number : ${order.tracking_number}\n`;
                                                                            }

                                                                            if (order.tracking_number) {
                                                                                //msg += `Tracking Number : ${order.tracking_number}\n`;
                                                                                msg += `Tracking Link : ${order.tracking_link}\n`;
                                                                            }

                                                                            // msg += "\n"; // space between orders
                                                                        });

                                                                        state.liveAgentMessage = msg;

                                                                    });
                                                                    let stateMessage = '';
                                                                    if (state.issue_type) {
                                                                        stateMessage += `Issue Type : ${state.issue_type}\n`;
                                                                    }
                                                                    if (state.delivery_issue) {
                                                                        stateMessage += `Delivery Issue : ${state.delivery_issue}\n`;
                                                                    }
                                                                    if (state.cancel_request) {
                                                                        stateMessage += `Reason to Cancel : ${state.cancel_request}\n`;
                                                                    }
                                                                    if (state.changes_request) {
                                                                        stateMessage += `Changes : ${state.changes_request}\n`;
                                                                    }
                                                                    if (state.damage_issue) {
                                                                        stateMessage += `Damage  : ${state.damage_issue}\n`;
                                                                    }
                                                                    // if(state.issue_type && state.damage_subtype!='' && state.damage_subtype!==null && state.damage_subtype!==undefined) {
                                                                    //   stateMessage += `Damage Type : ${state.damage_subtype}\n`;
                                                                    // }

                                                                    if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                                                        stateMessage += `Order number : ${state.order_number}\n`;
                                                                    }

                                                                    //state.liveAgentMessage = stateMessage //Issue type message will set to LiveAgentMeesage

                                                                } else {
                                                                    state.liveAgentMessage = "Customer contacted support without order verification.";
                                                                }

                                                                state.lock_step = null;
                                                                state.show_history = false;
                                                                state.active = "fallback_message";
                                                                state.fromBack = true;
                                                                //state.active = 'fallback_message';//order_confirmation_damage'
                                                                render()
                                                            }

                                                            ctl.appendChild(deliveryInput)
                                                            row.appendChild(el('div')) // spacer
                                                            row.appendChild(nextBtn)

                                                            ctl.appendChild(row)*/
                            }
                        })
                        break

                    case 'damage_concern':
                        console.log('start damage_concern');
                        cardToRender = card({
                            id: 'damage_concern',
                            title: 'Damage',
                            hint: "What items were damaged and how did it happen? Was the box damaged as well? (provide as many details as you can so we can investigate)",
                            controls: ctl => {
state.showOnlineChatOnBack=true;
                                // EMAIL
                                const deliveryInput = el('textarea', {
                                    class: 'sw-input',
                                    placeholder: 'Reason',
                                    value: state.damage_issue || ''
                                })
                                ////herree

                                const row = el('div', {class: 'sw-row between'})

                                // FIND ORDER
                                const nextBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Submit'
                                })

                                // nextBtn.disabled = true
                                nextBtn.disabled = state.damage_issue === ""

                                deliveryInput.oninput = e => {
                                    state.damage_issue = e.target.value
                                    nextBtn.disabled = state.damage_issue === ""
                                }

                                nextBtn.onclick = async () => {
                                    state.fromBack = true
                                    state.active = 'damage_upload'
                                    render()
                                }

                                ctl.appendChild(deliveryInput)
                                row.appendChild(el('div')) // spacer
                                row.appendChild(nextBtn)

                                ctl.appendChild(row)
                            }
                        })
                        break

                    case 'general_concern':
                        console.log('start general_concern');
                        cardToRender = card({
                            id: 'general_concern',
                            title: 'General Concern',
                            hint: 'Hi what questions do you have?',
                            controls: ctl => {
state.showOnlineChatOnBack=true;
                                // EMAIL
                                const generalInput = el('textarea', {
                                    class: 'sw-input',
                                    placeholder: 'What is your concern?',
                                    value: state.general_question
                                })
                                ////herree general_question

                                const row = el('div', {class: 'sw-row between'})

                                // FIND ORDER
                                const nextBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Submit'
                                })

                                // nextBtn.disabled = true
                                nextBtn.disabled = state.general_question === ""

                                generalInput.oninput = e => {
                                    state.general_question = e.target.value
                                    nextBtn.disabled = state.general_question === ""
                                }

                                nextBtn.onclick = async () => {
                                    state.fromBack = true
                                    state.active = 'general_email'

                                    render()
                                }

                                ctl.appendChild(generalInput)
                                row.appendChild(el('div')) // spacer
                                row.appendChild(nextBtn)

                                ctl.appendChild(row)
                            }
                        })
                        break


                    case 'cancel_upload':
                        console.log('start cancel_upload');
                        cardToRender = card({
                            id: 'cancel_upload',
                            title: 'Damage',
                            hint: "Please upload a photo of the damaged items and/or packaging. We accept .jpg and .png files. Note: This is a mandatory step.",
                            controls: ctl => {
state.showOnlineChatOnBack=true;
                                // EMAIL
                                const deliveryInput = el('input', {
                                    class: 'sw-input',
                                    type: 'file',
                                    // placeholder: 'Reason',
                                    value: state.damage_files || ''
                                })
                                ////herree

                                const row = el('div', {class: 'sw-row between'})

                                // FIND ORDER
                                const nextBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Submit'
                                })

                                // nextBtn.disabled = true
                                nextBtn.disabled = !state.damage_files || state.damage_files.length === 0

                                deliveryInput.onchange = e => {
                                    const files = [...e.target.files]

                                    // Filter only allowed types
                                    const validFiles = files.filter(file =>
                                        ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
                                    )

                                    state.damage_files = validFiles
                                    nextBtn.disabled = validFiles.length === 0
                                }

                                nextBtn.onclick = () => {
                                    state.fromBack = true
                                    state.active = 'order_confirmation_damage'
                                    render()
                                }

                                ctl.appendChild(deliveryInput)

                                row.appendChild(nextBtn)

                                ctl.appendChild(row)
                            }
                        })
                        break
                    case 'damage_upload':
                        console.log('start damage_upload');
                        cardToRender = card({
                            id: 'damage_upload',
                            title: 'Damage',
                            hint: "Please upload a photo of the damaged items and/or packaging. We accept .jpg and .png files. Note: This is a mandatory step.",
                            controls: ctl => {
state.showOnlineChatOnBack=true;
                                // EMAIL
                                const deliveryInput = el('input', {
                                    class: 'sw-input',
                                    type: 'file',
                                    // placeholder: 'Reason',
                                    value: state.damage_files || ''
                                })

                                const row = el('div', {class: 'sw-row  sw-row-send-request'})


                                // actions row
                                //const row = el('div', {class: 'sw-row'})

                                // live chat button
                                /*const chatBtn = el('button', {
                                    class: 'sw-btn ghost',
                                    type: 'button',
                                    text: 'Chat with us'
                                })
                                chatBtn.onclick = () => {
                                    liveAgentOpenChat({
                                        containerEl: null,
                                        prefill: {
                                            email: state.email,
                                            message: state.message
                                        }
                                    })
                                }*/

                                // send request button
                                const sendBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Send request'
                                })
                                sendBtn.disabled = !state.damage_files || state.damage_files.length === 0
                                // sendBtn.onclick = e => {
                                //     e.stopPropagation()
                                //     //state.active = 'submit'
                                //     state.active = 'submit'
                                //     state.fromBack = true
                                //     render()
                                // }


                                // FIND ORDER
                                /* const nextBtn = el('button', {
                                     class: 'sw-btn primary',
                                     type: 'button',
                                     text: 'Submit'
                                 })

                                 // nextBtn.disabled = true
                                 nextBtn.disabled = !state.damage_files || state.damage_files.length === 0
     */
                                deliveryInput.onchange = e => {
                                    const files = [...e.target.files]

                                    // Filter only allowed types
                                    const validFiles = files.filter(file =>
                                        ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
                                    )

                                    state.damage_files = validFiles
                                    sendBtn.disabled = validFiles.length === 0
                                }

                                sendBtn.onclick = () => {
                                    state.fromBack = true


                                    if (Array.isArray(state.orders) && state.orders.length > 0) {
                                        const orders = state.orders;
                                        orders.forEach(order => {
                                            let msg = "";//Customer contacted support with order verification\n";
                                            //msg += "============================================================\n\n";

                                            state.orders.forEach((order, index) => {
                                                //msg += `Order ${index + 1}\n`;
                                                //msg += `-----------\n`;
                                                //msg += `Order Number : ${order.order_number}\n`;
                                                msg += `Customer Email : ${state.email}\n`;
                                                msg += `Bill To : ${order.bill_to}\n`;
                                                msg += `Shipping Status : ${order.shipping_status}\n`;
                                                msg += `Payment Status: ${order.payment_status}\n`;
                                                msg += `Payment Method: ${order.payment_method}\n`;
                                                if (order.shipping_status !== 'unfulfilled' && order.tracking_number != '') {
                                                    msg += `Tracking number : ${order.tracking_number}\n`;
                                                }

                                                if (order.tracking_number) {
                                                    //msg += `Tracking Number : ${order.tracking_number}\n`;
                                                    msg += `Tracking Link : ${order.tracking_link}\n`;
                                                }

                                                // msg += "\n"; // space between orders
                                            });

                                            state.liveAgentMessage = msg;

                                        });
                                        let stateMessage = '';
                                        if (state.issue_type) {
                                            stateMessage += `Issue Type : ${state.issue_type}\n`;
                                        }
                                        if (state.delivery_issue) {
                                            stateMessage += `Delivery Issue : ${state.delivery_issue}\n`;
                                        }
                                        if (state.cancel_request) {
                                            stateMessage += `Reason to Cancel : ${state.cancel_request}\n`;
                                        }
                                        if (state.changes_request) {
                                            stateMessage += `Changes : ${state.changes_request}\n`;
                                        }
                                        if (state.damage_issue) {
                                            stateMessage += `Damage  : ${state.damage_issue}\n`;
                                        }
                                        // if(state.issue_type && state.damage_subtype!='' && state.damage_subtype!==null && state.damage_subtype!==undefined) {
                                        //   stateMessage += `Damage Type : ${state.damage_subtype}\n`;
                                        // }

                                        if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                            stateMessage += `Order number : ${state.order_number}\n`;
                                        }

                                        //state.liveAgentMessage = stateMessage //Issue type message will set to LiveAgentMeesage

                                    } else {
                                        state.liveAgentMessage = "Customer contacted support without order verification.";
                                    }

                                    state.lock_step = null;
                                    state.show_history = false;
                                    state.active = 'submit'
                                    //state.active = "fallback_message";
                                    state.fromBack = true;
                                    //state.active = 'fallback_message';//order_confirmation_damage'
                                    render()
                                }


                                //row.appendChild(chatBtn)
                                row.appendChild(sendBtn)
                                //ctl.appendChild(row)

                                ctl.appendChild(deliveryInput)
                                //row.appendChild(nextBtn)
                                ctl.appendChild(row)

                                // ctl.appendChild(deliveryInput)
                                // row.appendChild(nextBtn)
                                // ctl.appendChild(row)
                            }
                        })
                        break

                    case 'general_email':
                        console.log('start general_email');
                        cardToRender = card({
                            id: 'general_email',
                            title: 'How should we contact you?',
                            hint: 'What is your email?',
                            controls: ctl => {
state.showOnlineChatOnBack=true;
                                const generalEmail = el('input', {
                                    class: 'sw-input',
                                    placeholder: 'Email',
                                    value: state.email || ''
                                })
                                ////herree

                                const row = el('div', {class: 'sw-row between'})

                                // FIND ORDER
                                const nextBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Submit'
                                })

                                // nextBtn.disabled = true
                                nextBtn.disabled = state.email === ""

                                generalEmail.oninput = e => {
                                    state.email = e.target.value
                                    nextBtn.disabled = state.email === ""
                                }

                                nextBtn.onclick = async () => {
                                    state.active = 'submit'
                                    render()
                                }

                                ctl.appendChild(generalEmail)

                                row.appendChild(nextBtn)

                                ctl.appendChild(row)
                            }
                        })
                        break


                    case 'thank_you':
                        console.log('start thank_you');
                        cardToRender = card({
                            id: 'thank_you',
                            title: 'Thank You',
                            hint: 'Thank you for your inquiry and shopping with us!.',
                            controls: ctl => {
                                state.showOnlineChatOnBack=false;
                                ctl.appendChild(
                                    el('div', {
                                        class: 'sw-thank-you-text',
                                        text: 'Your trust in our business means the world to us, and we are committed to providing you with excellent service. We look forward to welcoming you back soon.'
                                    })
                                )
                            }
                        })
                        break


                    case 'order_fields':
                        console.log('start order_fields');
                        const needsOrder = isOrderRelated(state.issue_type)
                        cardToRender = card({
                            id: 'order_fields',
                            title: needsOrder
                                ? 'Provide order details'
                                : 'How should we contact you?',
                            hint: needsOrder
                                ? state.has_order_number
                                    ? 'Enter your order number and confirm your email.'
                                    : 'Enter your email and postal code to find the order.'
                                : 'Enter your email so we can respond.',
                            mini: orderMini(),
                            controls: ctl => {
                                // Email
                                ctl.appendChild(
                                    el('div', {class: 'sw-hint', text: 'Email used at checkout'})
                                )
                                const email = el('input', {
                                    class: 'sw-input',
                                    type: 'email',
                                    value: state.email,
                                    placeholder: 'you@email.com'
                                })
                                email.oninput = e => {
                                    state.email = e.target.value
                                }
                                // email.onblur = () => render();
                                ctl.appendChild(email)


                                const createTicket = el("button", {
                                    class: "sw-btn ghost",
                                    type: "button",
                                    text: "Submit Ticket"
                                });
                                createTicket.onclick = async (e) => {
                                    e.stopPropagation();
                                    state.order_back = false;
                                    const emailValue = (state.email || "").trim();

                                    // check empty value for email field
                                    if (!emailValue) {
                                        state.verify_status = {
                                            text: "Email is required before contacting support.",
                                            color: "red"
                                        };
                                        render();
                                        return;
                                    }
                                    state.message = '';
                                    state.liveAgentMessage = '';
                                    if (Array.isArray(state.orders) && state.orders.length > 0) {
                                        const orders = state.orders;
                                        orders.forEach(order => {
                                            let msg = "";//Customer contacted support with order verification\n";
                                            //msg += "============================================================\n\n";

                                            state.orders.forEach((order, index) => {
                                                msg += `Customer Email : ${state.email}\n`;
                                                msg += `Bill To : ${order.bill_to}\n`;
                                                msg += `Ship To : ${order.ship_to}\n`;
                                            });

                                            state.liveAgentMessage = msg;

                                        });

                                        if (state.email && state.email !== null) {
                                            state.liveAgentMessage += 'Email: ' + state.email;
                                        }
                                        let stateMessage = '';
                                        if (state.issue_type) {
                                            stateMessage += `Issue Type : ${state.issue_type}\n`;
                                        }
                                        if (state.issue_type && state.damage_subtype != '' && state.damage_subtype !== null && state.damage_subtype !== undefined) {
                                            stateMessage += `Damange Type : ${state.damage_subtype}\n`;
                                        }

                                        if (state.order_number != '' && state.order_number !== null && state.order_number !== undefined) {
                                            stateMessage += `Order number : ${state.order_number}\n`;
                                        }

                                        state.message = stateMessage

                                    } else {
                                        state.liveAgentMessage = "Customer contacted support without order verification.";
                                    }

                                    if (!state.message) {
                                        state.message = "";//Customer contacted support without order verification.";
                                    }

                                    state.lock_step = null;
                                    state.show_history = false;
                                    state.active = "fallback_message";
                                    state.fromBack = true;
                                    render();
                                };

                                ctl.appendChild(createTicket)


                                if (needsOrder) {
                                    if (state.has_order_number) {
                                        ctl.appendChild(
                                            el('div', {class: 'sw-hint', text: 'Order number'})
                                        )
                                        const ord = el('input', {
                                            class: 'sw-input',
                                            type: 'text',
                                            value: state.order_number,
                                            placeholder: 'e.g., 1234'
                                        })
                                        ord.oninput = e => {
                                            state.order_number = e.target.value
                                            state.order_found = null
                                        }

                                        const row = el('div', {class: 'sw-row'})
                                        const verify = el('button', {
                                            class: 'sw-btn ghost',
                                            type: 'button',
                                            text: 'Find order'
                                        })

                                        let result = ''
                                        verify.onclick = e => {
                                            e.stopPropagation()

                                            let result = ''
                                            state.tracking_modal_first_open = false
                                            if (
                                                state.order_number === 'MSC72817' &&
                                                state.email === 'abuchan@live.ca'
                                            ) {
                                                result = 'success'
                                            } else {
                                                result = 'failed'
                                            }

                                            state.lookup_status = result // ✅ persist in state

                                            if (result === 'success') {
                                                state.verify_status = {
                                                    text: historyTestData.at(-1).title,
                                                    color: 'green'
                                                }
                                                state.lock_step = 'order_fields'
                                            } else {
                                                state.verify_status = {
                                                    text: 'Order not found.',
                                                    color: 'red'
                                                }
                                                state.lock_step = 'order_fields'
                                            }

                                            render()
                                        }

                                        const st = el('div', {
                                            class: 'sw-status',
                                            text: state.verify_status?.text || ''
                                        })

                                        if (state.lookup_status === 'success') {
                                            st.style.cursor = 'pointer'

                                            st.onclick = e => {
                                                e.stopPropagation()
                                                state.tracking_modal_open = true
                                                render()
                                            }
                                        }

                                        if (state.verify_status?.color) {
                                            st.style.color = state.verify_status.color
                                        }

                                        ctl.appendChild(ord)

                                        row.appendChild(verify)
                                        row.appendChild(st)

                                        //hereeeee
                                        ctl.appendChild(row)

                                    } else {
                                        ctl.appendChild(
                                            el('div', {class: 'sw-hint', text: 'Postal code'})
                                        )
                                        const pc = el('input', {
                                            class: 'sw-input',
                                            type: 'text',
                                            value: state.postal_code,
                                            placeholder: 'Postal code'
                                        })
                                        pc.oninput = e => {
                                            state.postal_code = e.target.value
                                            state.order_found = null
                                        }
                                        pc.onblur = () => render()
                                        ctl.appendChild(pc)

                                        const row = el('div', {class: 'sw-row'})
                                        const find = el('button', {
                                            class: 'sw-btn ghost',
                                            type: 'button',
                                            text: 'Find my order'
                                        })
                                        const st = el('div', {
                                            class: 'sw-status',
                                            id: 'sw-findStatus'
                                        })
                                        find.onclick = e => {
                                            e.stopPropagation()
                                            state.fromBack = false

                                            lookup(st)

                                            switch (state.lookup_status) {
                                                case 'success':
                                                    state.verify_status = {
                                                        text: 'We found it(sample tracking history)',
                                                        color: 'green'
                                                    }
                                                    state.lock_step = 'order_fields'
                                                    break

                                                case 'failed':
                                                    state.verify_status = {
                                                        text: 'There was an error looking up the order.',
                                                        color: 'red'
                                                    }
                                                    state.lock_step = 'order_fields'
                                                    break

                                                case 'empty':
                                                    state.verify_status = {
                                                        text: 'The order does not exist.',
                                                        color: 'red'
                                                    }
                                                    state.lock_step = 'order_fields'
                                                    break

                                                default:
                                                    break
                                            }
                                            render()
                                        }
                                        row.appendChild(find)
                                        ctl.appendChild(row)
                                        ctl.appendChild(st)
                                    }
                                }
                            }
                        })
                        break

                    case 'message':
                        console.log('start message');
                        cardToRender = card({
                            id: 'message',
                            title: 'Describe the issue',
                            hint: 'A few details help us resolve this faster. (Max 600 characters)',
                            mini: state.message
                                ? `Message added (${clamp(state.message, 60)}${
                                    state.message.length > 60 ? '…' : ''
                                })`
                                : '',
                            controls: ctl => {
                                state.showOnlineChatOnBack=true;
                                const ta = el('textarea', {
                                    class: 'sw-textarea',
                                    maxlength: '600',
                                    placeholder: 'What happened? What outcome would you like?'
                                })
                                ta.value = state.message || ''
                                ta.oninput = e => {
                                    state.message = clamp(e.target.value, 600)
                                }
                                ta.onblur = () => render()
                                ctl.appendChild(ta)
                            }
                        })
                        break

                    case 'submit':
                        console.log('submit ticket should be', state);

                        cardToRender = card({
                            id: 'submit',
                            title: 'Ready to submit',
                            hint: 'Submit your request. If an agent is available, you can also chat after submission.',
                            controls: ctl => {
                                state.showOnlineChatOnBack=true;
                                const submit = el('button', {
                                    id: 'sw-submitStatus',
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: state.submitting ? 'Submitting…' : 'Submit request'
                                })
                                submit.disabled = state.submitting
                                submit.onclick = e => {
                                    e.stopPropagation()
                                    submitTicket();
                                    state.thank_you_switch = true
                                    console.log('state after click', state);

                                }


                                const row = el('div', {class: 'sw-row chatUs'})

                                // live chat button
                                /*const chatBtn = el('button', {
                                    class: 'sw-btn ghost',
                                    type: 'button',
                                    text: 'Chat with us'
                                })
                                chatBtn.onclick = () => {
                                    liveAgentOpenChat({
                                        containerEl: null,
                                        prefill: {
                                            email: state.email,
                                            message: state.message
                                        }
                                    })
                                }*/


                                var issueCopyRequest = '';
                                if (state.issue_type === 'DELIVERY') {
                                    issueCopyRequest = state.delivery_issue
                                }
                                if (state.issue_type === 'GENERAL') {
                                    issueCopyRequest = state.general_question
                                }
                                if (state.issue_type === 'DAMAGE') {
                                    issueCopyRequest = state.damage_issue
                                }
                                if (state.issue_type === 'CHANGES') {
                                    issueCopyRequest = state.changes_request;

                                }
                                if (state.issue_type === 'CANCEL') {
                                    issueCopyRequest = state.cancel_request
                                }

                                if (issueCopyRequest !== '') {
                                    issueCopyRequest = `<div class="sw-prompt">Issue: ${issueCopyRequest}</div>`;

                                    if (state.issue_type === 'CHANGES') {
                                        if (state.change_request_type!==null && state.change_request_type!=='')
                                        {
                                            issueCopyRequest += `<div class="sw-prompt">Type of changes: ${state.change_request_type}</div>`;
                                        }
                                    }
                                }
                                const customerData = el("div", {
                                    class: "sw-confirm data-review", html: `
                                  <div class="sw-prompt">Customer name: ${state.customerName}</div>
                                  <div class="sw-prompt">Customer email: ${state.email}</div>
                                  <div class="sw-prompt">Order number: ${state.order_number}</div>
                                  ${issueCopyRequest}                                  
                                  `
                                })
                                ctl.appendChild(customerData);

                                //row.appendChild(chatBtn);
                                row.appendChild(submit);
                                ctl.appendChild(row);


                                //ctl.appendChild(submit);
                                if (state.submitting_error != null && state.submitting_error != undefined && state.submitting_error != '') {
                                    ctl.appendChild(el("div", {
                                        class: "sw-confirm", html: `
                      <div class="sw-prompt">${state.submitting_error}</div>
                    `
                                    }));
                                    state.submitting_error = '';
                                }
                                if (state.sendTicket && !state.submitting && state.liveAgentRef != null && state.liveAgentRef != undefined) {
                                    state.submitting_error = '';
                                    if (state.delivery_issue) {
                                        ctl.appendChild(el("div", {
                                            class: "sw-confirm", html: `
                  <div class="sw-prompt">✅ Request received</div>
                  <div class="sw-hint" style="display:block!important;">Ticket number: <strong>${escapeHtml(state.liveAgentRef)}</strong></div>
                  <div class="sw-hint" style="display:block!important;">Requests accepted 24/7. Live chat from 9am–8pm ET.</div>
                  <div class="sw-hint" style="display:block!important;">Thank you for submitting your concern! We have created a ticket to investigate your delivery issue. We will respond to you by email or phone in the next 24 hours. Thank you for your inquiry and shopping with us!</div>
                  `
                                        }));
                                    } else if (state.general_question) {
                                        ctl.appendChild(el("div", {
                                            class: "sw-confirm", html: `
                  <div class="sw-prompt">✅ Request received</div>
                  <div class="sw-hint" style="display:block!important;">Ticket number: <strong>${escapeHtml(state.liveAgentRef)}</strong></div>
                  <div class="sw-hint" style="display:block!important;">Requests accepted 24/7. Live chat from 9am–8pm ET.</div>
                  <div class="sw-hint" style="display:block!important;">Thank you for your general inquiry! We have created a ticket. We will respond to you by email or phone in the next 24 hours. If you would like to speak to live chat respond there.</div>
                  `
                                        }));
                                    } else if (state.cancel_request) {
                                        ctl.appendChild(el("div", {
                                            class: "sw-confirm", html: `
                  <div class="sw-prompt">✅ Request received</div>
                  <div class="sw-hint" style="display:block!important;">Ticket number: <strong>${escapeHtml(state.liveAgentRef)}</strong></div>
                  <div class="sw-hint" style="display:block!important;">Requests accepted 24/7. Live chat from 9am–8pm ET.</div>
                  <div class="sw-hint" style="display:block!important;">Thank you for submitting your concern! We have created a ticket so that we can cancel your order ASAP. We will respond to you by email or phone in the next 24 hours. NOTE: Order cancellation are prioritized. Thank you for your inquiry and shopping with us!</div>
                  `
                                        }));
                                    } else if (state.changes_request) {
                                        ctl.appendChild(el("div", {
                                            class: "sw-confirm", html: `
                  <div class="sw-prompt">✅ Request received</div>
                  <div class="sw-hint" style="display:block!important;">Ticket number: <strong>${escapeHtml(state.liveAgentRef)}</strong></div>
                  <div class="sw-hint" style="display:block!important;">Requests accepted 24/7. Live chat from 9am–8pm ET.</div>
                  <div class="sw-hint" style="display:block!important;">Thank you for submitting your concern! We have created a ticket so that we can make a change to your order. We will respond to you by email or phone in the next 24 hour NOTE: Order changes are prioritized. Thank you for your inquiry and shopping with us!</div>
                  `
                                        }));
                                    } else if (state.damage_issue) {
                                        ctl.appendChild(el("div", {
                                            class: "sw-confirm", html: `
                  <div class="sw-prompt">✅ Request received</div>
                  <div class="sw-hint" style="display:block!important;">Ticket number: <strong>${escapeHtml(state.liveAgentRef)}</strong></div>
                  <div class="sw-hint" style="display:block!important;">Requests accepted 24/7. Live chat from 9am–8pm ET.</div>
                  <div class="sw-hint" style="display:block!important;">Thank you for submitting your concern! We have created a ticket to investigate your issue related to damages. We will respond to you by email or phone in the next 24 hours & we will process a refund if we have all of the documentation. Thank you for your inquiry and shopping with us!</div>
                  `
                                        }));
                                    } else {
                                        ctl.appendChild(el("div", {
                                            class: "sw-confirm", html: `
                  <div class="sw-prompt">✅ Request received</div>
                  <div class="sw-hint" style="display:block!important;">Ticket number: <strong>${escapeHtml(state.liveAgentRef)}</strong></div>
                  <div class="sw-hint" style="display:block!important;">Requests accepted 24/7. Live chat from 9am–8pm ET.</div>
                  
                  `
                                        }));
                                    }
                                    const submitStatusButton = document.getElementById('sw-submitStatus');
                                    if (submitStatusButton !== undefined && submitStatusButton !== null) {
                                        submitStatusButton.style.display = 'none';
                                    }
                                    const swBackRow = document.querySelector('.sw-back-row');
                                    if (swBackRow !== undefined && swBackRow !== null)
                                        swBackRow.style.display = 'none';

                                    submit.style.display = 'none';

                                    customerData.innerHTML='';

                                    if (customerData!==null && customerData!==undefined)
                                    {
                                        customerData.remove();
                                    }

                                    // const reviewBlock = document.querySelector('.data-review');
                                    // if (reviewBlock!==null && reviewBlock!==undefined)
                                    //     reviewBlock.remove();//innerHTML='';

                                    // if (chatBtn!==null && chatBtn!==undefined)
                                    // {
                                    //     chatBtn.remove();
                                    // }
                                    // const btnGhost = document.querySelector('.sw-btn.ghost');
                                    // if (btnGhost!==null && btnGhost!==undefined) {
                                    //     btnGhost.style.display = 'none';
                                    //     console.log('display none', btnGhost);
                                    // }



                                    const moreBtn = el('button', {
                                        class: 'sw-btn sw-back-tiles',
                                        type: 'button',
                                        text: 'I have more questions'
                                    })

                                    moreBtn.onclick = e => {
                                        e.stopPropagation()

                                        state.fromBack = true
                                        state.active = 'issue';
                                        state.lock_step = null

                                        // state.issue_type = ''
                                        state.has_order_number = null
                                        state.wants_lookup = null
                                        state.order_number = ''
                                        state.postal_code = ''
                                        state.order_found = null
                                        state.verify_status = null
                                        state.lookup_status = null

                                        state.sendTicket = '';
                                        state.submitting = false;
                                        state.liveAgentRef = null;

                                        render()
                                    }

                                    ctl.appendChild(moreBtn);

                                    state.liveAgentRef = '';

                                }
                            }
                        })

                        break
                    case 'fallback_message':
                        console.log('start fallback_message');
                        cardToRender = card({
                            id: 'fallback_message',
                            title: 'I want to ask a question.',
                            hint: 'You can ask a question or chat with an agent.',
                            controls: ctl => {
                                state.showOnlineChatOnBack=true;
                                // textarea
                                const ta = el('textarea', {
                                    class: 'sw-textarea',
                                    placeholder: 'I want to ask a question…',
                                    maxlength: '600'
                                })
                                // console.log("MESSAGE: ", state.message)
                                ta.value = state.message || ''
                                // checkValues(ta.value)
                                ta.oninput = e => {
                                    state.message = clamp(e.target.value, 600)
                                    console.log("MESSAGE: ", state.message)
                                }
                                ctl.appendChild(ta)

                                // actions row
                                const row = el('div', {class: 'sw-row sw-row-send-request'})

                                // live chat button
                                /*const chatBtn = el('button', {
                                    class: 'sw-btn ghost',
                                    type: 'button',
                                    text: 'Chat with us'
                                })
                                chatBtn.onclick = () => {
                                    liveAgentOpenChat({
                                        containerEl: null,
                                        prefill: {
                                            email: state.email,
                                            message: state.message
                                        }
                                    })
                                }*/

                                // send request button
                                const sendBtn = el('button', {
                                    class: 'sw-btn primary',
                                    type: 'button',
                                    text: 'Send request'
                                })
                                sendBtn.onclick = e => {
                                    e.stopPropagation()
                                    //state.active = 'submit'
                                    state.active = 'submit'
                                    state.fromBack = true
                                    render()
                                }

                                //row.appendChild(chatBtn)
                                row.appendChild(sendBtn)
                                ctl.appendChild(row)
                            }
                        })
                        break
                }

                if (cardToRender) rail.appendChild(cardToRender)
                return rail
            }

            function emailAndOrderOk() {
                if (!nonEmpty(state.email)) return false
                if (!isOrderRelated(state.issue_type)) return true
                if (state.has_order_number === true) return nonEmpty(state.order_number)
                if (state.has_order_number === false) return nonEmpty(state.postal_code)
                return false
            }

            function labelForIssue(id) {
                const it = ISSUE.find(x => x.id === id)
                return it ? it.label : ''
            }

            function quickHint() {
                // if(state.issue_type==="ORDER_STATUS") return "Did the recipient receive the order?";
                if (state.issue_type === 'DELIVERY')
                    if (state.issue_type === 'DAMAGE') return 'What best describes the issue?'
                if (state.issue_type === 'CHANGES')
                    return 'What changes would you like to make to your order?'//What would you like to change?'
                if (state.issue_type === 'BILLING')
                    return 'What’s the reason for your request?'
                return 'No extra details needed.'
            }

            function quickMini() {
                // if(state.issue_type==="ORDER_STATUS" && state.recipient_received) return `Recipient received: ${state.recipient_received}`;
                if (state.issue_type === 'DAMAGE' && state.damage_subtype)
                    return `Issue: ${state.damage_subtype}`
                if (state.issue_type === 'CHANGES' && state.change_request_type)
                    return `Change: ${state.change_request_type}`
                if (state.issue_type === 'BILLING' && state.refund_reason)
                    return `Reason: ${state.refund_reason}`
                return ''
            }

            function orderMini() {
                if (!nonEmpty(state.email)) return ''
                if (!isOrderRelated(state.issue_type)) return `Email: ${state.email}`
                if (state.has_order_number === true)
                    return `Email: ${state.email} • Order: ${
                        state.order_number ? '#' + state.order_number : 'not entered'
                    }`
                if (state.has_order_number === false)
                    return `Email: ${state.email} • Postal: ${
                        state.postal_code || 'not entered'
                    }`
                return ''
            }

            async function lookup(statusEl) {
                if (!statusEl) return
                statusEl.textContent = 'Checking…'

                try {
                    const resp = await fetch(`${API_BASE}/order/lookup`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            domain: DOMAIN,
                            customer_email: (state.email || '').trim(),
                            postal_code: (state.postal_code || '').trim()
                        })
                    })

                    const json = await resp.json()
                    if (!json.ok) {
                        state.lookup_status = 'failed'
                        //change this
                        state.tracking_history = []
                        state.tracking_expanded = false

                        throw new Error(json.error || 'Lookup failed')
                    }
                    const orders = json.orders || []
                    if (!orders.length) {
                        state.lookup_status = 'empty'
                        state.order_found = null
                        statusEl.textContent =
                            'No matching orders found. Check email + postal code.'
                        render()
                        return
                    }
                    state.lookup_status = 'success'

                    //change this
                    state.tracking_history = data.tracking_history || []
                    state.tracking_expanded = false

                    const o = orders[0]
                    state.order_number = String(o.name || '').replace('#', '')
                    state.order_found = o
                    statusEl.textContent = `✅ Order ${state.order_number} found`
                    render()
                } catch (e) {
                    state.lookup_status = 'failed'
                    //change this
                    state.tracking_history = []
                    state.tracking_expanded = false
                    statusEl.textContent = e.message || 'Lookup error'
                }
            }

            //here
            async function lookupOrder(email, postal_code, order_number) {

                try {
                    const hasPostal = !!postal_code?.trim()
                    const hasOrder = !!order_number?.trim()

                    console.log("HASPOSTAL: ", hasPostal);
                    console.log("HASORDER: ", hasOrder);
                    console.log("XOR: ", (hasPostal ^ hasOrder));

                    if ((hasPostal ^ hasOrder) === 0) {
                        // both true or both false → invalid
                        return res.status(400).json({
                            message: 'Provide either postal code OR order number (not both).'
                        })
                    }

                    console.log("****printing domain: " + DOMAIN.replace(/^www\./, ''));
                    const resp = await fetch(`${API_BASE}/order/byOrderNumber`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            domain: DOMAIN.replace(/^www\./, ''),
                            email: (state.email).trim(),
                            postal_code: (postal_code || '').trim(),
                            order_number: (order_number || '').trim()

                        })
                    })

                    const json = await resp.json()

                    // console.log("JSON: ",json);

                    if (!resp.ok) {
                        // state.lookup_status = 'failed'
                        //change this
                        console.log("JSON: ", json);
                        state.tracking_history = []
                        state.tracking_expanded = false
                        // state.lookup_status = "Verify Order"
                        return "failed";
                    }
                    const orders = json.orders || []
                    if (!orders.length) {
                        // state.lookup_status = 'empty'
                        state.order_found = null
                        // statusEl.textContent =
                        //   'No matching orders found. Check email + postal code.'
                        // render()
                        return "empty";
                    }

                    state.orders = orders || [];
                    //if (orders.lenght>0)

                    //showOrders(orders);
                    // state.lookup_status = 'success'

                    //change this
                    // state.tracking_history = data.tracking_history || []
                    state.tracking_history = orders || []

                    state.tracking_expanded = false

                    const o = orders[0]
                    // state.order_number = String(o.order_number || '').replace('#', '')
                    // state.order_found = o;
                    render();
                    // statusEl.textContent = `✅ Order ${state.order_number} found`
                    return "success";
                    // render()
                } catch (e) {
                    console.log('error', e);
                    // state.lookup_status = 'failed'
                    //change this
                    state.tracking_history = []
                    state.tracking_expanded = false
                    return "failed";
                    // statusEl.textContent = e.message || 'Lookup error'
                }
            }

            function detailsHtml() {
                const issue = state.issue_type ? labelForIssue(state.issue_type) : '—'
                const email = nonEmpty(state.email) ? state.email : '—'
                const order = isOrderRelated(state.issue_type)
                    ? nonEmpty(state.order_number)
                        ? `#${state.order_number}`
                        : '—'
                    : 'Not required'
                const verify = state.order_found ? 'Verified ✅' : 'Not verified'
                const files = `${(state.files || []).length}/10`
                return `
        Issue: <strong>${escapeHtml(issue)}</strong><br/>
        Email: <strong>${escapeHtml(email)}</strong><br/>
        Order: <strong>${escapeHtml(order)}</strong><br/>
        Verification: <strong>${escapeHtml(verify)}</strong><br/>
        Attachments: <strong>${escapeHtml(files)}</strong>
      `
            }

            function escapeHtml(str) {
                return String(str || '').replace(
                    /[&<>"']/g,
                    s =>
                        ({
                            '&': '&amp;',
                            '<': '&lt;',
                            '>': '&gt;',
                            '"': '&quot;',
                            "'": '&#39;'
                        }[s])
                )
            }

            //   async function submitTicket () {
            //     const st = document.getElementById('sw-submitStatus')
            //     if (!st) return

            //     state.submitting = true
            //     st.textContent = 'Submitting…'
            //     render()

            //     try {
            //       const fd = new FormData()
            //       fd.append('domain', DOMAIN)
            //       fd.append('entry_source', 'support_button')
            //       fd.append('issue_type', state.issue_type)
            //       fd.append('order_number', (state.order_number || '').trim())
            //       fd.append('customer_email', (state.email || '').trim())
            //       fd.append('postal_code', (state.postal_code || '').trim())
            //       fd.append('message', (state.message || '').trim())

            //       fd.append('utm', JSON.stringify(getUTM()))
            //       ;(state.files || [])
            //         .slice(0, 10)
            //         .forEach(f => fd.append('files', f, f.name))

            //       const resp = await fetch(`${API_BASE}/support/ticket`, {
            //         method: 'POST',
            //         body: fd
            //       })
            //       const json = await resp.json()
            //       if (!json.ok) throw new Error(json.error || 'Submit failed')

            //       const ref = json.ticket_ref || json.ticket_id

            //       // Replace left rail with confirmation (feels premium)
            //       const leftEl = document.querySelector('.sw-left')
            //       if (leftEl) {
            //         leftEl.innerHTML = ''
            //         leftEl.appendChild(
            //           el('div', {
            //             class: 'sw-confirm',
            //             html: `
            //           <div class="sw-prompt">✅ Request received</div>
            //           <div class="sw-hint">Reference: <strong>${escapeHtml(
            //             ref
            //           )}</strong></div>
            //           <div class="sw-hint">Requests accepted 24/7. Live chat from 9am–8pm ET.</div>
            //         `
            //           })
            //         )
            //       }

            //       state.submitting = false
            //     } catch (e) {
            //       state.submitting = false
            //       st.textContent = e.message || 'Temporary error. Please try again.'
            //       render()
            //     }
            //   }

            //   render()
            // }
            async function uploadFiles(files) {
                const formData = new FormData();

                for (let file of files) {
                    formData.append("files", file);
                }

                const res = await fetch("https://your-backend.com/api/upload", {
                    method: "POST",
                    body: formData,
                });
//////
                const data = await res.json();
                return data.files; // contains S3 URLs
            }

            async function submitTicket(ctl) {
                console.log("*****inside submitTicekt********");
                console.log('state submitTicket', state);
                const st = document.getElementById("sw-submitStatus");
                if (!st) return;

                //console.log('sw-submitStatus on');
                state.submitting = true;
                //state.active='submit';
                st.textContent = "Submitting…";
                render();
                finalMessage = (state.message || "") + "\n\n"
                    + "==================Automate Order Details==================== \n\n"
                    + (state.liveAgentMessage || "");

                console.log('sw-submitStatus after render');
                state.sendTicket = false;
                try {
                    const fd = new FormData();
                    fd.append("domain", DOMAIN);
                    fd.append("entry_source", "support_button");
                    fd.append("issue_type", state.issue_type);
                    fd.append("order_number", (state.order_number || "").trim());
                    fd.append("delivery_issue", (state.delivery_issue || "").trim());
                    fd.append("customer_email", (state.email || "").trim());
                    fd.append("customer_name", (state.customerName || "").trim());
                    fd.append("postal_code", (state.postal_code || "").trim());
                    fd.append("message", (state.message || "").trim());
                    if (Array.isArray(state.orders) && state.orders.length > 0) {
                        const orders = state.orders;

                        orders.forEach(order => {
                            console.log('order', order);
                            fd.append("ship_to", (order.ship_to || "").trim());
                            fd.append("bill_to", (order.bill_to || "").trim());
                            fd.append("shipping_status", (order.shipping_status || ''));//(order.shipping_status || "").trim());
                            fd.append("payment_status", (order.payment_status || ''));
                            fd.append("payment_method", (order.payment_method || ''));
                            fd.append("tracking_link", (order.tracking_link || ''));
                            fd.append("tracking_number", (order.tracking_number || ''));

                            fd.append("warehouse", (order.warehouse || ''));
                        });
                    }

                    if (state.recipient_received) fd.append("recipient_received", state.recipient_received);
                    if (state.cancel_request) fd.append("cancel_request", state.cancel_request);
                    if (state.changes_request) fd.append("changes_request", state.changes_request);
                    if (state.damage_issue) fd.append("damage_issue", state.damage_issue);

                    //if (state.delivery_issue) fd.append("delivery_issue", state.delivery_issue);
                    if (state.damage_subtype) fd.append("damage_subtype", state.damage_subtype);
                    if (state.change_request_type) fd.append("change_request_type", state.change_request_type);
                    if (state.refund_reason) fd.append("refund_reason", state.refund_reason);
                    if (state.general_question) fd.append("general_question", state.general_question);

                    if (Array.isArray(state.damage_files) && state.damage_files.length > 0) {
                        fd.append("files", state.damage_files[0]);
                    }

                    fd.append("utm", JSON.stringify(getUTM()));
                    //(state.files||[]).slice(0,10).forEach(f=>fd.append("files", f, f.name));

                    console.log('fd', fd);
                    const resp = await fetch(`${API_BASE}/support/ticket`, {method: "POST", body: fd});
                    const json = await resp.json();
                    if (!json.ok) throw new Error(json.error || "Submit failed");
                    console.log('json ticket', json);
                    const ref = json.ticket_ref || json.ticket_id;

                    // Replace left rail with confirmation (feels premium)
                    const leftEl = document.querySelector(".sw-left");

                    if (leftEl) {
                        state.sendTicket = true;
                        // leftEl.innerHTML="";
                        // leftEl.appendChild(el("div",{class:"sw-confirm",html:`
                        //   <div class="sw-prompt">✅ Request received</div>
                        //   <div class="sw-hint">Reference: <strong>${escapeHtml(ref)}</strong></div>
                        //   <div class="sw-hint">Requests accepted 24/7. Live chat from 9am–8pm ET.</div>
                        // `}));
                    }
                    // live chat from 9am to 8pm ET
                    //   const rightEl=document.querySelector(".sw-right");
                    //   if(rightEl){
                    //     rightEl.innerHTML="";
                    //     rightEl.appendChild(el("div",{class:"sw-sBox",html:`<div class="sw-sKey">Next</div><div class="sw-sVal">We’ll reply by email.</div>`}));
                    //   }

                    state.liveAgentRef = ref;

                    state.submitting = false;
                    render();
                } catch (e) {
                    console.log('e', e);
                    state.submitting = false;
                    state.submitting_error = e.message || "Temporary error. Please try again.";
                    st.textContent = e.message || "Temporary error. Please try again.";
                    render();
                }
            }

            render();
        }

        function init() {
            mount()
        }

        if (document.readyState === 'loading')
            document.addEventListener('DOMContentLoaded', init)
        else init()
    }

)
()